/* 17H13 V2 — vanilla runtime. Re-implements the dc-prototype component logic
   (header hide, overlays, carousels, reveals, email capture) on real Shopify
   commerce (Cart AJAX API + Section Rendering API + predictive search). */
(function () {
  'use strict';

  var CFG = window.h13Cfg || {};
  var root = null;
  var cartCount = CFG.cartCount || 0;
  var state = { ov: { email: false, set: false, bag: false, search: false, menu: false, exit: false } };
  var OV_KEYS = ['exit', 'email', 'set', 'bag', 'search', 'menu']; // close-priority order (prototype closeTop); 'exit' first so Escape dismisses it before anything under it
  var emailStep = 0;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  // currency-aware (2026-09-16): A$ / C$ outside the US, matching snippets/money-prefix.liquid
  var CUR_ISO = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var CUR_SYM = CUR_ISO === 'USD' ? '$' : CUR_ISO === 'AUD' ? 'A$' : CUR_ISO === 'CAD' ? 'C$' : CUR_ISO + ' $';
  function fmt(cents) { var v = (cents / 100).toFixed(2); return CUR_SYM + (v.slice(-3) === '.00' ? v.slice(0, -3) : v); } // $39, A$44.90

  /* ---------- overlays ---------- */
  function ovEl(name) { return $('[data-ov="' + name + '"]'); }
  function anyOv() { return OV_KEYS.some(function (k) { return state.ov[k]; }); }
  var bagWasOpen = false;
  var ovClosing = {};      // overlays mid exit-animation stay visible until their timer fires
  var ovCloseTimers = {};
  function syncOv() {
    OV_KEYS.forEach(function (k) {
      var el = ovEl(k);
      if (el && !ovClosing[k]) el.hidden = !state.ov[k];
    });
    var lock = anyOv() ? 'hidden' : '';
    document.body.style.overflow = lock;
    document.documentElement.style.overflow = lock;
    if (state.ov.bag && !bagWasOpen) { armWalletFallback(); revealBagRails(); }
    bagWasOpen = !!state.ov.bag;
    reserveSync();
  }
  function openOv(name) {
    if (!ovEl(name)) return;
    if (name === 'email' && state.ov.bag) closeOv('bag'); // the popup never stacks over an open bag (2026-09-17)
    if (ovClosing[name]) { // reopened mid close-animation: cancel the exit cleanly
      ovClosing[name] = false;
      clearTimeout(ovCloseTimers[name]);
      ovEl(name).classList.remove('h13-ov-closing');
    }
    state.ov[name] = true;
    syncOv();
    if (name === 'search') { var si = $('[data-search-input]'); if (si) si.focus(); }
    if (name === 'email') { var ei = $('[data-email-input]'); if (ei && emailStep === 0) ei.focus(); }
  }
  function closeOv(name) {
    var el = ovEl(name);
    if ((name === 'email' || name === 'exit') && state.ov[name]) {
      try { sessionStorage.setItem(name === 'email' ? 'h13_email_closed_at' : 'h13_exit_closed_at', String(Date.now())); } catch (e) {}
    }
    // the menu opens on a fade, so the close replays it in reverse (.h13-ov-closing in
    // h13-base.css) before hidden is set; reduced-motion closes instantly as before
    if (el && !el.hidden && name === 'menu' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      state.ov[name] = false;
      ovClosing[name] = true;
      el.classList.add('h13-ov-closing');
      clearTimeout(ovCloseTimers[name]);
      ovCloseTimers[name] = setTimeout(function () {
        ovClosing[name] = false;
        el.classList.remove('h13-ov-closing');
        syncOv();
      }, 240);
      syncOv();
      return;
    }
    state.ov[name] = false;
    syncOv();
    if (name === 'search') { // prototype closeSearch resets q
      var si = $('[data-search-input]');
      var idle = $('[data-search-idle]');
      var res = $('[data-search-results]');
      if (si) si.value = '';
      if (idle) idle.hidden = false;
      if (res) { res.hidden = true; res.innerHTML = ''; }
    }
  }
  function closeTop() {
    for (var i = 0; i < OV_KEYS.length; i++) {
      var k = OV_KEYS[i];
      if (state.ov[k]) {
        if (k === 'email') dismissEmail(); else closeOv(k);
        return;
      }
    }
  }

  /* ---------- header hide on scroll down / show on up ---------- */
  var lastY = window.scrollY;
  var maxScroll = 0;
  var pageScrolled = false;
  function onScroll() {
    var y = window.scrollY;
    var dh = document.documentElement.scrollHeight - window.innerHeight;
    if (dh > 0) maxScroll = Math.max(maxScroll, y / dh);
    if (!emailScrolled && (CFG.template === 'collection' || CFG.template === 'product') && dh > 0 && (y + window.innerHeight) / document.documentElement.scrollHeight >= 0.5) {
      emailScrolled = true;
      maybeEmail();
    }
    // announcement bar leaves once the page has moved; it (and the pills' 32px offset)
    // only come back at the very top — html.h13-scrolled drives both in CSS
    var scrolledNow = y > 40;
    if (scrolledNow !== pageScrolled) {
      pageScrolled = scrolledNow;
      document.documentElement.classList.toggle('h13-scrolled', scrolledNow);
    }
    // The wordmark used to slide away on scroll-down. It stays now — the whole chrome
    // band (announcement + header) is pinned at every scroll position (Adam 2026-08-19).
    lastY = y;
  }

  /* ---------- cart ---------- */
  /* ---------- bag reservation timer (2026-09-14) ---------- */
  // Soft hold, display only: nothing is ever removed. The expiry lives in localStorage so it
  // survives page loads; the drawer is re-rendered from the server after every cart op, so
  // reserveRender() re-finds [data-bag-reserve] each time (called from replaceBagSection).
  // Every successful add resets the clock; an empty bag clears it; at 0 the line reads
  // "Reservation ended" until the next add. Minutes come from the element's data attribute
  // (Theme settings > Bag > bag_reserve_minutes; 0 renders nothing server-side).
  var RESERVE_KEY = 'h13_bag_reserve';
  var reserveTimer = null;
  // cached hooks: the 1s tick never queries the document; the cache is rebuilt whenever
  // the drawer / cart section / PDP scope re-renders (reserveCacheRefresh)
  var reserveEls = null, reserveSlots = null;
  function reserveCacheRefresh() { reserveEls = $$('[data-bag-reserve]'); reserveSlots = $$('[data-bag-reserve-slot]'); }
  function reserveClock(left) { var mm = Math.floor(left / 60), ss = left % 60; return (mm < 10 ? '0' + mm : mm) + ':' + (ss < 10 ? '0' + ss : ss); }
  function reserveGet() { try { return parseInt(localStorage.getItem(RESERVE_KEY), 10) || 0; } catch (e) { return 0; } }
  function reserveSet(v) { try { if (v) localStorage.setItem(RESERVE_KEY, String(v)); else localStorage.removeItem(RESERVE_KEY); } catch (e) {} }
  function reserveMinutes() {
    if (!reserveEls) reserveCacheRefresh();
    var el = reserveEls[0] || $('[data-bag-reserve]');
    var m = el ? parseInt(el.getAttribute('data-reserve-minutes'), 10) : NaN;
    return isNaN(m) ? 15 : m;
  }
  function reserveBump() {
    var m = reserveMinutes();
    if (m <= 0) { reserveSet(0); return; }
    reserveSet(Date.now() + m * 60000);
    reserveRender();
  }
  // The clock starts ONLY in reserveBump() after a real add. A bag that was already there
  // on page load shows nothing until the next add (no stored expiry = no line anywhere).
  function reserveRender() {
    if (!reserveEls) reserveCacheRefresh();
    if (!reserveEls.length && !reserveSlots.length) return;
    var exp = reserveGet();
    var left = exp ? Math.max(0, Math.round((exp - Date.now()) / 1000)) : 0;
    var clock = exp ? reserveClock(left) : '';
    reserveEls.forEach(function (el) {
      var txt = $('[data-reserve-text]', el);
      var time = $('[data-reserve-time]', el);
      if (!exp) { el.hidden = true; return; }
      var sentence = el.hasAttribute('data-reserve-sentence'); // exit popup: "Saved on this device for 14:32."
      if (left <= 0) { el.hidden = true; return; } else {
        if (txt) txt.textContent = sentence ? 'Bag reserved for you for' : 'Bag reserved for you';
        if (time) time.textContent = sentence ? clock : '\u00b7 ' + clock;
      }
      el.hidden = false;
    });
    // PDP sticky bar slot (<span data-bag-reserve-slot hidden>, main-product): same text
    reserveSlots.forEach(function (sl) {
      if (!exp) { sl.hidden = true; sl.textContent = ''; return; }
      sl.textContent = left <= 0 ? 'Reservation ended' : 'Bag reserved for you \u00b7 ' + clock;
      sl.hidden = false;
    });
  }
  function reserveSync() {
    if (!reserveEls) reserveCacheRefresh();
    var want = !!state.ov.bag || !!state.ov.exit || CFG.template === 'cart' || (reserveSlots.length > 0 && reserveGet() > 0);
    if (want && !reserveTimer) { reserveRender(); reserveTimer = setInterval(reserveRender, 1000); }
    else if (!want && reserveTimer) { clearInterval(reserveTimer); reserveTimer = null; }
  }

  function updateCount(n) {
    cartCount = n;
    if (n === 0) reserveSet(0);
    reserveRender();
    // "Bag (0)": no zero padding (2026-09-17 audit)
    var padded = String(n);
    $$('[data-bag-count]').forEach(function (el) { el.textContent = padded; });
    // an empty bag arms no back-trap; arm it the moment the bag stops being empty
    if (cartCount > 0) exitArmBack();
  }
  /* Wallets: one accelerated-checkout wallet per platform, plus the theme's own
     CHECKOUT pill. Apple devices that can run Apple Pay get Apple Pay; everything
     else (Windows, Android, and Apple devices where Apple Pay is unavailable, e.g.
     Chrome on a Mac) gets Shop Pay. Shopify renders the wallet row inside a closed
     shadow root, so hiding buttons after the fact is not possible — instead the
     <shopify-accelerated-checkout-cart wallet-configs> JSON is trimmed BEFORE the
     element upgrades (theme JS is deferred; Shopify's PaymentButton.init runs on
     DOMContentLoaded), and section re-renders are trimmed while still detached. */
  // The trim itself lives in snippets/wallet-trim.liquid (inline in <head>, so it runs before
  // Shopify's portable-wallets module on the cart page). It exposes window.h13WalletChoice()
  // and window.h13TrimWallets(root); this file only consumes them.
  function walletChoice() { return window.h13WalletChoice ? window.h13WalletChoice() : 'shop_pay'; }
  function trimWalletsIn(root) { if (window.h13TrimWallets) window.h13TrimWallets(root); }
  function filterWallets() {
    var want = walletChoice() === 'apple_pay' ? 'apple' : 'shop';
    $$('.h13-wallet').forEach(function (w) {
      var items = $$('ul > li', w);
      if (!items.length) items = $$('[data-shopify-buttoncontainer] > div', w);
      if (items.length < 2) return;
      items.forEach(function (li) {
        var html = (li.outerHTML || '').toLowerCase();
        if (html.indexOf('skeleton') !== -1) return;
        if (html.indexOf(want) !== -1) li.removeAttribute('data-h13-wallet-hide');
        else li.setAttribute('data-h13-wallet-hide', '');
      });
    });
  }
  var walletMO = null;
  function watchWallets() {
    trimWalletsIn(document);
    filterWallets();
    if (walletMO) walletMO.disconnect();
    walletMO = new MutationObserver(function () { filterWallets(); });
    $$('.h13-wallet').forEach(function (w) { walletMO.observe(w, { childList: true, subtree: true }); });
    armWalletFallback();
  }
  /* The trim keeps ONE wallet. On Apple devices that is Apple Pay — and Shopify's Apple Pay
     button can decline to render (no active card in Wallet, domain check, in-app browser),
     which would leave the shopper with no wallet at all. If the kept wallet has not
     materialised 2.5s after the bag is on screen, re-create the element with Shop Pay. */
  var walletFallbackT = null;
  function armWalletFallback() {
    if (walletFallbackT) { clearTimeout(walletFallbackT); walletFallbackT = null; }
    if (!state.ov.bag) return;
    walletFallbackT = setTimeout(function () {
      walletFallbackT = null;
      if (!state.ov.bag) return;
      $$('.h13-wallet shopify-accelerated-checkout-cart[data-h13-trimmed]').forEach(function (el) {
        if (el.getAttribute('data-h13-trimmed') === 'shop_pay') return;
        if (el.getBoundingClientRect().height >= 20) return; // something rendered — keep it
        var cfg;
        try { cfg = JSON.parse(el.getAttribute('data-h13-wallet-raw') || '[]'); } catch (e) { return; }
        var kept = cfg.filter(function (c) { return c && c.name === 'shop_pay'; });
        if (!kept.length) return;
        var fresh = document.createElement(el.tagName.toLowerCase());
        Array.prototype.forEach.call(el.attributes, function (a) { fresh.setAttribute(a.name, a.value); });
        fresh.setAttribute('wallet-configs', JSON.stringify(kept));
        fresh.setAttribute('data-h13-trimmed', 'shop_pay');
        fresh.setAttribute('data-h13-wallet-fallback', el.getAttribute('data-h13-trimmed'));
        el.parentNode.replaceChild(fresh, el);
      });
    }, 2500);
  }

  function replaceBagSection(html) {
    var wrap = document.getElementById('shopify-section-bag-drawer');
    if (!wrap || !html) return;
    // parse detached (DOMParser docs have no custom-element registry, so nothing
    // upgrades yet), trim the wallet list, then serialise back in
    var doc = new DOMParser().parseFromString(html, 'text/html');
    trimWalletsIn(doc);
    var inner = doc.getElementById('shopify-section-bag-drawer');
    wrap.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
    syncOv();
    refreshDiscountUI();
    watchWallets();
    renderTryon();
    reserveCacheRefresh();
    reserveRender();
    revealBagRails();
  }
  window.h13ReplaceBagSection = replaceBagSection; // bag-meter-auto.liquid re-renders through this, never a raw innerHTML swap
  // "Complete the look" rail: server-rendered hidden, shown one frame after the drawer
  // is on screen so the first paint is items + pinned checkout
  function revealBagRails() {
    if (!state.ov.bag) return;
    requestAnimationFrame(function () { $$('[data-bag-rail]').forEach(function (r) { r.hidden = false; }); });
  }
  // ---- cart try-on (ledger #62) — evaluation of v1/v2/v3 in the real drawer ----
  // Active only with ?tryon=v1|v2|v3 (session-sticky; ?tryon=off clears). Production-safe:
  // without the flag the [data-tryon] block stays hidden. v2's composites are stand-in
  // frames (multi-piece worn shots already in product media) keyed by sorted handles;
  // the real batch replaces the map's values with rendered composites.
  var TRYON_COMBOS = {
    'baroque-pearl-station-necklace-7061+baroque-pearl-studs-6865': 'baroque-pearl-studs-6865',
    'amethyst-dreams-bracelet-9360+baroque-pearl-station-necklace-7061': 'amethyst-dreams-bracelet-9360',
    'baroque-pearl-station-necklace-7061+baroque-pearl-studs-6865+dual-gem-statement-ring-8494': 'baroque-pearl-studs-6865'
  };
  function tryonMode() {
    try {
      var m = new URLSearchParams(location.search).get('tryon');
      if (m === 'off') { sessionStorage.removeItem('h13_tryon'); return ''; }
      if (m === 'v1' || m === 'v2' || m === 'v3') sessionStorage.setItem('h13_tryon', m);
      return sessionStorage.getItem('h13_tryon') || '';
    } catch (e) { return ''; }
  }
  var tryonGen = 0;
  function tryonStrip(stage, items) {
    stage.innerHTML = '<div data-tryon-frames style="position:absolute;inset:0;display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none">' +
      items.map(function (it) {
        return '<img alt="' + it.title + ' worn" src="' + it.worn + '" loading="lazy" style="width:100%;flex:none;object-fit:cover;object-position:top;scroll-snap-align:start">';
      }).join('') + '</div>' +
      (items.length > 1 ? '<div style="position:absolute;top:9px;left:11px;display:flex;gap:5px">' + items.map(function (_, i) {
        return '<i data-tryon-dot style="width:5px;height:5px;border-radius:50%;background:#F4F1EA;opacity:' + (i === 0 ? '1' : '.45') + '"></i>';
      }).join('') + '</div>' : '');
    var frames = stage.querySelector('[data-tryon-frames]');
    if (frames) frames.addEventListener('scroll', function () {
      var i = Math.round(frames.scrollLeft / frames.clientWidth);
      stage.querySelectorAll('[data-tryon-dot]').forEach(function (d, j) { d.style.opacity = j === i ? '1' : '.45'; });
    }, { passive: true });
  }
  function tryonSingle(stage, url, alt) {
    stage.innerHTML = '<img alt="' + alt + '" src="' + url + '" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:top">';
  }
  // Bag re-rendered: refresh the slim trigger row; any open popup closes (the bag
  // changed under it). The try-on itself lives in the [data-tryon-pop] overlay.
  function renderTryon() {
    var pop = document.querySelector('[data-tryon-pop]');
    var trig = document.querySelector('[data-tryon-open]');
    tryonGen++;
    if (pop) pop.hidden = true;
    if (!trig) return;
    var mode = tryonMode();
    var items = tryonItems();
    if (!mode || !items.length) { trig.hidden = true; return; }
    trig.hidden = false;
    var thumb = trig.querySelector('[data-tryon-thumb]');
    if (thumb && thumb.getAttribute('src') !== items[0].worn) thumb.src = items[0].worn;
    var count = trig.querySelector('[data-tryon-count]');
    if (count) count.textContent = items.length + (items.length === 1 ? ' piece' : ' pieces');
  }
  function tryonItems() {
    return $$('[data-tryon-item]').map(function (el) {
      return { handle: el.getAttribute('data-handle'), title: el.getAttribute('data-title'), worn: el.getAttribute('data-worn') };
    });
  }
  function openTryonPop() {
    var pop = document.querySelector('[data-tryon-pop]');
    if (!pop) return;
    var mode = tryonMode();
    var items = tryonItems();
    if (!mode || !items.length) return;
    var stage = pop.querySelector('[data-tryon-stage]');
    var label = pop.querySelector('[data-tryon-label]');
    var note = pop.querySelector('[data-tryon-note]');
    var micro = pop.querySelector('[data-tryon-micro]');
    if (micro) micro.hidden = false;
    var run = ++tryonGen;
    var byHandle = {};
    items.forEach(function (it) { byHandle[it.handle] = it; });
    var key = items.map(function (it) { return it.handle; }).sort().join('+');
    var comboSrc = TRYON_COMBOS[key] || (items.length === 1 ? items[0].handle : null);
    var combo = comboSrc && byHandle[comboSrc] ? byHandle[comboSrc] : null;
    pop.hidden = false;
    if (mode === 'v1') {
      tryonStrip(stage, items);
      if (label) label.textContent = 'WORN' + (items.length > 1 ? ' \u00b7 SWIPE' : '');
      if (note) note.textContent = items.length + ' OF ' + items.length + ' FROM PRODUCT MEDIA';
    } else if (mode === 'v2') {
      if (combo) {
        tryonSingle(stage, combo.worn, 'Your bag, worn');
        if (label) label.textContent = 'YOUR BAG \u00b7 ONE FRAME';
        if (note) note.textContent = 'PRE-RENDERED';
      } else {
        tryonStrip(stage, items);
        if (label) label.textContent = 'WORN \u00b7 SWIPE';
        if (note) note.textContent = 'COMBO NOT RENDERED \u00b7 LOGGED';
      }
    } else if (mode === 'v3') {
      var img = combo ? combo.worn : items[items.length - 1].worn;
      stage.innerHTML = '<div style="position:absolute;inset:0;background:linear-gradient(100deg,transparent 30%,rgba(20,18,16,.08) 50%,transparent 70%) var(--placeholder);background-size:220% 100%;animation:h13TryonSh 1.2s linear infinite"></div>';
      if (label) label.textContent = 'COMPOSING HER LOOK\u2026';
      if (note) note.textContent = 'RENDERING';
      if (micro) micro.hidden = true;
      setTimeout(function () {
        if (run !== tryonGen) return;
        if (label) label.textContent = 'QUALITY CHECK\u2026';
      }, 4200);
      setTimeout(function () {
        if (run !== tryonGen) return;
        tryonSingle(stage, img, 'Your bag, worn');
        if (label) label.textContent = 'GENERATED \u00b7 7.4S';
        if (note) note.textContent = 'QA 4.1/5';
        if (micro) micro.hidden = false;
      }, 7400);
    }
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-tryon-open]')) { openTryonPop(); return; }
    if (e.target.closest('[data-tryon-close]')) {
      var p = document.querySelector('[data-tryon-pop]');
      if (p) { p.hidden = true; tryonGen++; }
    }
  });
  /* one-line mono toast at the bottom of the drawer, 2.5s; survives the drawer re-render
     because it lives on <body>, positioned just above the pinned summary */
  var toastT = null;
  function bagToast(msg) {
    if (!msg) return;
    var el = document.getElementById('h13-bag-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'h13-bag-toast';
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);z-index:70;max-width:calc(100vw - 32px);padding:9px 14px;border-radius:999px;background:var(--text);color:var(--bg);font-family:ui-monospace,\'SF Mono\',Menlo,monospace;font-size:9.5px;letter-spacing:.14em;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none;transition:opacity .2s ease';
      document.body.appendChild(el);
    }
    var sum = $('[data-ov="bag"] [data-bag-summary]');
    var bottom = 24;
    if (sum && state.ov.bag) { var r = sum.getBoundingClientRect(); bottom = Math.max(24, Math.round(window.innerHeight - r.top + 8)); }
    el.style.bottom = bottom + 'px';
    el.textContent = msg;
    el.hidden = false; el.style.opacity = '1';
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.style.opacity = '0'; setTimeout(function () { el.hidden = true; }, 220); }, 2500);
  }
  window.h13Toast = bagToast;

  function refreshBag() {
    fetch('/?section_id=bag-drawer')
      .then(function (r) { return r.text(); })
      .then(replaceBagSection)
      .catch(function () {});
  }
  function cartAdd(items, openBag) {
    var ok = false;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: cartSectionsParam() })
    })
      .then(function (r) {
        ok = r.ok;
        return r.json();
      })
      .then(function (d) {
        if (d && d.status) ok = false; // Cart API error payload
        settleSections(d);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (c) {
        if (c && typeof c.item_count === 'number') updateCount(c.item_count);
        if (ok) reserveBump();
        if (openBag) {
          state.ov.menu = false;
          state.ov.search = false;
          state.ov.set = false;
          state.ov.bag = true;
          syncOv();
        }
        refreshDiscountUI();
        return ok;
      })
      .catch(function () { return false; });
  }
  window.h13CartAdd = cartAdd;
  // /cart page: the main-cart section rides the same Cart API call (sections=bag-drawer,<id>)
  // and is swapped in place, so a quantity change or a code no longer reloads the page.
  function cartPageSection() {
    if (CFG.template !== 'cart') return null;
    var page = $('.h13-page');
    var wrap = page && page.closest ? page.closest('[id^="shopify-section-"]') : null;
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }
  function cartSectionsParam() { var cs = cartPageSection(); return cs ? 'bag-drawer,' + cs : 'bag-drawer'; }
  function replaceCartPage(sections) {
    var cs = cartPageSection();
    if (!cs || !sections || !sections[cs]) return;
    var wrap = document.getElementById('shopify-section-' + cs);
    if (!wrap) return;
    var doc = new DOMParser().parseFromString(sections[cs], 'text/html');
    trimWalletsIn(doc);
    var inner = doc.getElementById('shopify-section-' + cs);
    var y = window.pageYOffset;
    wrap.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
    window.scrollTo(0, y);
    watchWallets();
    reserveCacheRefresh();
    reserveRender();
  }
  function settleSections(c) {
    if (c && c.sections && c.sections['bag-drawer']) replaceBagSection(c.sections['bag-drawer']);
    if (c && c.sections) replaceCartPage(c.sections);
  }
  function cartChange(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: cartSectionsParam() })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        settleSections(c);
        if (c && typeof c.item_count === 'number') updateCount(c.item_count);
        refreshDiscountUI();
      })
      .catch(function () {});
  }

  /* ---------- first-order discount display ---------- */
  function discountActive() {
    try { return localStorage.getItem('h13v2_discount') === '1'; } catch (e) { return false; }
  }
  /* The bag's discount rows and subtotal are Shopify's own numbers, rendered
     server-side from cart.discount_applications (2026-08-19). There is no longer a
     browser-side "hint" row: it used to invent a FIRST ORDER line and rewrite the
     subtotal from a localStorage flag, which could show money off that checkout would
     not take. When the popup applies the code, the drawer is simply re-rendered. */
  function refreshDiscountUI() {
    $$('[data-bag-summary] [data-discount-row]').forEach(function (row) { row.hidden = true; });
    // Empty-bag offer rows (rendered only when the cart is empty): the joined visitor
    // whose cookie carries the current code sees it riding the bag; everyone else sees
    // the offer with a way onto the list. If the heal fetch is still in flight this
    // shows JOIN for a beat, then corrects on the refreshBag() re-render it triggers.
    var joined = discountActive() && earnedCode() && (cookieCode() === earnedCode() || promoApplied().indexOf(earnedCode()) >= 0);
    var mine = $('[data-bag-summary] [data-empty-discount]');
    var join = $('[data-bag-summary] [data-empty-discount-join]');
    if (mine) mine.style.display = joined ? 'flex' : 'none';
    if (join) join.style.display = joined ? 'none' : 'flex';
  }

  /* ---------- promo code (2026-09-02) ----------
     Bag summary + cart page (snippets/promo-code.liquid; both bag variants share it).
     Apply/remove go through POST /cart/update.js { discount: "A,B" } — Shopify stores
     the codes on the cart, reports each one back as discount_codes[].applicable, and
     carries them into checkout (verified 2026-09-02; the same call is what the /discount
     route ends in). The applied chips are server-rendered from cart.discount_applications
     in the section re-render the call returns, so the totals are Shopify's numbers
     (cart-level + line discount allocations), never theme math. A code Shopify declines
     is posted off again before the error line shows, so checkout never sees it. */
  function promoRemovedThisSession(code) {
    try { return !!code && sessionStorage.getItem('h13_promo_off') === code; } catch (e) { return false; }
  }
  function promoApplied() {
    // the cart page renders the block twice (drawer + page), same server state: dedupe
    return $$('[data-promo-chip]').map(function (c) { return c.getAttribute('data-promo-code') || ''; })
      .filter(function (c, i, a) { return c && a.indexOf(c) === i; });
  }
  function promoPost(codes, withSections) {
    var body = { discount: codes.join(',') };
    if (withSections) body.sections = cartSectionsParam();
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function promoSettle(cart) {
    settleSections(cart);
    if (cart && typeof cart.item_count === 'number') updateCount(cart.item_count);
    refreshDiscountUI();
  }
  function promoBusy(box, on) {
    var b = $('[data-promo-apply]', box);
    if (!b) return;
    b.disabled = on;
    b.setAttribute('aria-busy', on ? 'true' : 'false');
    b.textContent = on ? '…' : 'Apply';
  }
  function promoError(box, msg) {
    var e = $('[data-promo-err]', box);
    if (e) { e.textContent = msg; e.hidden = false; }
    var i = $('[data-promo-input]', box);
    if (i) { i.setAttribute('aria-invalid', 'true'); i.focus(); }
  }
  function promoClearError(box) {
    var e = $('[data-promo-err]', box);
    if (e) { e.hidden = true; e.textContent = ''; }
    var i = $('[data-promo-input]', box);
    if (i) i.removeAttribute('aria-invalid');
  }
  function promoApply(box) {
    if (!box) return;
    var btn = $('[data-promo-apply]', box);
    if (btn && btn.disabled) return; // one in flight (Enter while APPLY is busy)
    var input = $('[data-promo-input]', box);
    var code = input ? input.value.trim().toUpperCase() : '';
    if (!code) { if (input) input.focus(); return; }
    var have = promoApplied();
    if (have.indexOf(code) > -1) { promoError(box, 'That code is already on this bag.'); return; }
    promoClearError(box);
    promoBusy(box, true);
    promoPost(have.concat(code), true)
      .then(function (cart) {
        if (!cart || cart.status) throw new Error('cart');
        var hit = (cart.discount_codes || []).filter(function (d) { return d && String(d.code).toUpperCase() === code; })[0];
        if (hit && hit.applicable) { promoSettle(cart); return; }
        // Shopify declined it: take it back off the cart so checkout never carries it
        return promoPost(have, false).then(function () {
          promoBusy(box, false);
          promoError(box, 'That code doesn’t apply to this bag.');
        });
      })
      .catch(function () { promoBusy(box, false); promoError(box, 'That didn’t go through. Try again.'); });
  }
  function promoRemove(box, code) {
    if (!code) return;
    var keep = promoApplied().filter(function (c) { return c !== code; });
    var chip = box && $('[data-promo-chip][data-promo-code="' + code.replace(/"/g, '') + '"]', box);
    if (chip) chip.setAttribute('aria-busy', 'true');
    if (code === CFG.firstOrderCode || code === earnedCode()) {
      // the first-order code also lives in Shopify's discount_code cookie (set by the
      // /discount route) and would ride back on the next render; drop it, and stop the
      // heal-on-boot from re-applying it for the rest of this session
      document.cookie = 'discount_code=; Max-Age=0; path=/; SameSite=Lax';
      try { sessionStorage.setItem('h13_promo_off', code); } catch (e) {}
    }
    promoPost(keep, true)
      .then(function (cart) { if (!cart || cart.status) throw new Error('cart'); promoSettle(cart); })
      .catch(function () { if (chip) chip.removeAttribute('aria-busy'); });
  }
  // Enter applies (the cart page's input sits inside the cart <form>, whose default
  // submit is CHECKOUT); typing clears a previous error
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || !e.target.closest) return;
    var i = e.target.closest('[data-promo-input]');
    if (!i) return;
    e.preventDefault();
    promoApply(i.closest('[data-promo]'));
  });
  document.addEventListener('input', function (e) {
    var i = e.target && e.target.closest && e.target.closest('[data-promo-input]');
    if (i) promoClearError(i.closest('[data-promo]'));
  });

  /* ---------- email capture ---------- */
  function emailSuppressed() {
    try {
      if (localStorage.getItem('h13v2_email_done') === '1') return true;
      var ts = +localStorage.getItem('h13v2_email_dismissed') || 0;
      return !!ts && (Date.now() - ts) < 7 * 864e5;
    } catch (e) { return false; }
  }
  var emailFired = false;
  var emailTimer = null;
  var elapsed = 0;
  var emailScrolled = false; // 50% of a collection / product page seen this view
  try { elapsed = +sessionStorage.getItem('h13v2_elapsed') || 0; } catch (e) {}
  // page views this session: the landing view (1) never opens the newsletter
  function pageViews() { try { return +sessionStorage.getItem('h13v2_pv') || 0; } catch (e) { return 0; } }
  function bumpPageView() { try { sessionStorage.setItem('h13v2_pv', String(pageViews() + 1)); } catch (e) {} }
  // 10-minute cooldown between the two modals, both ways (sessionStorage timestamps set in closeOv)
  var MODAL_COOLDOWN = 10 * 60000;
  function closedWithin(key) { try { var ts = +sessionStorage.getItem(key) || 0; return !!ts && (Date.now() - ts) < MODAL_COOLDOWN; } catch (e) { return false; } }
  function emailCooldown() { return closedWithin('h13_exit_closed_at'); }
  function exitCooldown() { return closedWithin('h13_email_closed_at'); }
  function pdpOpens() {
    try { return +sessionStorage.getItem('h13v2_pdp_opens') || 0; } catch (e) { return 0; }
  }
  // ---- three-step first-order capture: ask -> email -> done (phone step retired 2026-08-19) ----
  var EMAIL_STEPS = ['play', 'email', 'done'];
  var EMAIL_DONE = EMAIL_STEPS.length - 1;
  // Legacy game entry points cannot exceed the current signup offer.
  function playTier(n) {
    var base = CFG.firstOrderPct || 10, pct = Math.min(base, 15);
    var code = pct > base ? 'PLAY' + pct : (CFG.firstOrderCode || '');
    return { n: n, pct: pct, ship: false, code: code, codes: code ? [code] : [] };
  }
  function earnedCode() { return CFG.firstOrderCode || ''; }
  function earnedCodes() { return CFG.firstOrderCode ? [CFG.firstOrderCode] : []; }
  function earnedPct() { return CFG.firstOrderPct || 10; }
  var emailState = { step: 0, intent: '', intentCat: '', intentUrl: '', answer: '', email: '' };
  try { emailState = Object.assign(emailState, JSON.parse(localStorage.getItem('h13v2_email_state') || '{}')); } catch (e) {}
  // states saved by the old four-step flow: 2 was "phone" (email already captured), 3 was done
  if (emailState.step > EMAIL_DONE) emailState.step = EMAIL_DONE;
  delete emailState.phone;
  function saveEmailState() { try { localStorage.setItem('h13v2_email_state', JSON.stringify(emailState)); } catch (e) {} }
  // ---- popup visual A/B (Adam 2026-09-01): two Theme-settings images, sticky 50/50.
  // Assignment persists in emailState so a visitor never sees both; the signup carries
  // capture-img-a / capture-img-b as a customer tag. Random assignment means the two
  // tag counts compare directly — no impression counter needed.
  function assignCaptureVariant() {
    var medias = $$('[data-capture-var]');
    if (medias.length < 2) {                       // test off: drop any stale assignment
      if (emailState.imgVar) { delete emailState.imgVar; saveEmailState(); }
      return;
    }
    if (emailState.imgVar !== 'a' && emailState.imgVar !== 'b') {
      emailState.imgVar = Math.random() < 0.5 ? 'a' : 'b';
      saveEmailState();
    }
    medias.forEach(function (m) { m.hidden = m.getAttribute('data-capture-var') !== emailState.imgVar; });
  }
  function maybeEmail() {
    if (CFG.template !== 'index' || !CFG.emailEnabled || emailFired || state.ov.email) return;
    if (emailSuppressed()) { emailFired = true; if (emailTimer) clearInterval(emailTimer); return; }
    var delay = Math.max(2, CFG.emailDelay || 5);
    var ready = elapsed >= delay;
    var bagEl = $('[data-ov="bag"]'); if (bagEl && !bagEl.hidden) return; // never over an open bag (Adam 2026-09-17)
    if (ready && !anyOv() && !emailCooldown()) {
      emailFired = true;
      if (emailTimer) clearInterval(emailTimer);
      setEmailStep(emailState.step || 0);
      openOv('email');
    }
  }
  function setEmailStep(n) {
    if(n === 0) n = 1;
    var prev = emailStep;
    emailStep = n;
    emailState.step = n;
    saveEmailState();
    assignCaptureVariant();
    // popup-v2 2026-09-17: a step change while the popup is open is one 320ms cross-fade
    // (old lifts 8px out, new rises 8px in) and the panel height eases between the two;
    // reduced motion = instant. Only the step cells move, the dots keep their place.
    var panelEl = $('.h13-email-panel');
    var animate = panelEl && state.ov.email && prev !== n && prev >= 0 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var prevEl = animate ? $('[data-email-step="' + EMAIL_STEPS[prev] + '"]') : null;
    var nextEl = $('[data-email-step="' + EMAIL_STEPS[n] + '"]');
    var h0 = animate ? panelEl.offsetHeight : 0;
    EMAIL_STEPS.forEach(function (k, i) {
      var el = $('[data-email-step="' + k + '"]');
      if (el) { el.hidden = i !== n; el.classList.remove('is-leaving', 'is-entering'); }
    });
    if (animate && prevEl && nextEl) {
      panelEl.classList.remove('is-anim'); panelEl.style.height = '';
      var h1 = panelEl.offsetHeight;                 // target height, measured with the old step gone
      nextEl.classList.add('is-entering');
      prevEl.classList.add('is-leaving');
      panelEl.style.height = h0 + 'px';
      void panelEl.offsetHeight;                     // commit the start frame
      panelEl.classList.add('is-anim');
      panelEl.style.height = h1 + 'px';
      nextEl.classList.remove('is-entering');
      clearTimeout(panelEl._stepT);
      panelEl._stepT = setTimeout(function () { prevEl.classList.remove('is-leaving'); panelEl.classList.remove('is-anim'); panelEl.style.height = ''; }, 340);
    }
    $$('[data-email-dots] i').forEach(function (d, i) { d.classList.toggle('on', i <= n); });
    var shop = $('[data-email-shop]');
    var lbl = $('[data-email-shop-label]');
    if (shop) shop.setAttribute('href', '/collections/all');
    var pct = earnedPct();
    if (lbl) {
      var what = emailState.intentCat ? emailState.intentCat.toLowerCase() : '';
      lbl.textContent = what ? 'Shop ' + what + ' with ' + pct + '% off' : 'Shop with ' + pct + '% off';
    }
    $$('[data-email-pct]').forEach(function (el) { el.textContent = pct + '%'; });
    var codeEl = $('[data-email-code]'); if (codeEl) codeEl.textContent = earnedCodes().join(' + ');
    var earnedEl = $('[data-email-earned]');
    if (earnedEl) {
      var p = emailState.play;
      // one line (2026-09-17 sweep-b): "4 pearls · 20%" / "Enter your email"
      // popup-v2: the % sits large beside it in the strip, so this line is only the count
      earnedEl.textContent = p && p.n > 0 ? (p.n >= 6 ? 'necklace complete' : p.n + (p.n === 1 ? ' pearl' : ' pearls')) + (p.ship ? ' + free shipping' : '') : 'the floor';
    }
    var panel = $('.h13-email-panel'); if (panel) panel.classList.toggle('is-play', n === 0);
    if (n === 0) { playButtons(false); pearlsStart(900); }
    if (n === 1) {
      pearlsStrip((emailState.play && emailState.play.n) || 0);
      var ei = $('[data-email-input]');
      if (ei && ei.value === '' && emailState.email) ei.value = emailState.email;
      setTimeout(function () { var f = $('[data-email-input]'); if (f) f.focus(); }, 60);
    }
  }
  function applyDiscountCode() {
    var codes = earnedCodes();
    if (!codes.length) return;
    // /discount/CODE sets Shopify's discount cookie; then /cart/update.js { discount } puts
    // the code(s) on the cart itself (discount_codes[].applicable) and re-renders the bag
    // so its chip, rows and subtotal show the code the way checkout will. Posting the list
    // replaces whatever was on the cart, so a better replay code takes over (2026-09-17).
    fetch('/discount/' + encodeURIComponent(codes[0]), { keepalive: true }).then(function () {
      return promoPost(codes, true).then(promoSettle, function () { refreshBag(); });
    }, function () {});
  }
  function cookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  // The joined flag outlives the discount cookie (new session, expired cookie, a code
  // that rotated since signup, a LIST15-era join). Every surface that says "applied"
  // leans on that flag, so re-point the cookie at the current code whenever they disagree.
  function healDiscountCookie() {
    if (promoRemovedThisSession(CFG.firstOrderCode)) return; // they took it off the bag themselves
    if (discountActive() && earnedCode() && cookieCode() !== earnedCode() && promoApplied().indexOf(earnedCode()) < 0) applyDiscountCode();
  }
  function fillCaptureForm() {
    var form = $('[data-email-form]');
    if (!form) return null;
    var tags = ['newsletter', 'denim'];
    var t = $('[data-email-tags]', form); if (t) t.value = tags.join(',');
    var n = $('[data-email-note]', form); if (n) n.value = emailState.answer ? 'answer: ' + emailState.answer : (emailState.intent ? 'intent: ' + emailState.intent : '');
    var e = $('[data-email-input]', form); if (e && emailState.email && !e.value) e.value = emailState.email;
    return form;
  }
  /* Stamp the Klaviyo profile with the exact code the site showed, so the welcome
     email prints the same code ({{ person|lookup:'first_order_code' }}) and the flow
     can route on the answer. Fire-and-forget; never blocks or delays the form. */
  function stampKlaviyoProfile(form) {
    try {
      if (!CFG.klaviyoId) return;
      var el = $('[data-email-input]', form);
      var email = ((el && el.value) || emailState.email || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
      var props = { first_order_code: earnedCode(), first_order_pct: earnedPct(), play_pearls: (emailState.play && emailState.play.n) || 0, play_ship: !!(emailState.play && emailState.play.ship), intent: emailState.intent || 'everything', capture_img: emailState.imgVar || '' };
      var body = { data: { type: 'profile', attributes: { email: email, properties: props } } };
      fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(CFG.klaviyoId), { method: 'POST', keepalive: true, headers: { 'content-type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) }).catch(function () {});
    } catch (err) {}
  }
  /* Submit the customer form. First try in place (works when Shopify's spam-protection
     captcha is off). If Shopify answers 400 (captcha token required) hand the very same
     form to Shopify's captcha handler via a native submit — the page navigates to /contact
     and back, and boot() reopens the popup at the next step from the saved state. */
  function submitCapture(nextStep) {
    var form = fillCaptureForm();
    if (!form || !form.reportValidity()) return;
    if (form.getAttribute('data-h13-busy') === '1') return;
    form.setAttribute('data-h13-busy', '1');
    form.setAttribute('data-h13-native', '1');
    emailState.step = 1; saveEmailState();
    try { sessionStorage.setItem('h13v2_email_native', '1'); } catch (e) {}
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
    setTimeout(function () { form.removeAttribute('data-h13-busy'); }, 1500);
  }
  function markJoined() {
    try {
      localStorage.setItem('h13v2_email_done', '1');
      localStorage.setItem('h13v2_discount', '1');
      sessionStorage.removeItem('h13_promo_off');
    } catch (e) {}
    applyDiscountCode();
    refreshDiscountUI();
  }
  // Step 1 is a tap, not a typed answer (Adam 2026-08-18). Every option is a real
  // collection, so the intent tag maps 1:1 to a handle and SHOP lands somewhere real.
  function chooseIntent(btn) {
    emailState.intent = btn.getAttribute('data-email-intent') || '';
    emailState.intentCat = btn.getAttribute('data-intent-cat') || '';
    emailState.intentUrl = btn.getAttribute('data-intent-url') || '';
    emailState.answer = btn.textContent.trim();
    saveEmailState();
    // done-step chips (games v3): the tag rides a second profile stamp, the link navigates
    var form = $('[data-email-form]'); if (form) stampKlaviyoProfile(form);
  }
  /* replay 2026-09-17 (Adam): a run that ends waits for "Take the X%" or "Play again"; the
     best tier of the session is what counts (never lower), three replays a session, and the
     accepted code goes onto the cart at once (applyDiscountCode) so the bag shows the chip. */
  var MAX_REPLAYS = 3;
  function replaysUsed() { try { return +sessionStorage.getItem('h13v2_play_replays') || 0; } catch (e) { return 0; } }
  function replaysLeft() { return Math.max(0, MAX_REPLAYS - replaysUsed()); }
  function keepBestPlay(tier) {
    var best = emailState.play;
    if (!best || tier.pct > best.pct || (tier.pct === best.pct && tier.n > (best.n || 0))) emailState.play = tier;
    saveEmailState();
  }
  function playButtons(over) {
    var skip = $('[data-email-skip]'), again = $('[data-play-again]'), tries = $('[data-play-tries]'), left = replaysLeft();
    if (skip) skip.textContent = (over ? 'Take the ' : 'Skip, take the ') + earnedPct() + '%';
    if (again) again.hidden = !over || left <= 0;
    if (tries) { tries.hidden = !over || left <= 0; tries.textContent = left + (left === 1 ? ' try left' : ' tries left'); }
  }
  function acceptPlay() { keepBestPlay(playTier(0)); pearlsStop(); applyDiscountCode(); setEmailStep(1); }
  function skipPlay() { acceptPlay(); }
  function replayPlay() {
    if (replaysLeft() <= 0 || !pearls || !pearls.over) return;
    try { sessionStorage.setItem('h13v2_play_replays', String(replaysUsed() + 1)); } catch (e) {}
    playButtons(false);
    pearlsStart(500);
  }

  /* ---------- Stack the pearls (popup step 1, games v3 2026-09-16) ----------
     A pearl swings across the top; tap to drop. It sits if it overlaps the pearl below by
     ~28% or more, squashes on landing, and each pearl swings faster. A miss rolls off and
     ends the run at the tier already reached. Six slots; the necklace strands turn gold from
     the ends inward as pearls land; the % grows live. Ported from dashboard/apps/popup-options
     G11. Reduced motion: the pearl steps between three positions instead of swinging. */
  var pearls = null;
  function pearlsStop() { if (pearls) { cancelAnimationFrame(pearls.raf); pearls.raf = 0; pearls.live = false; } }
  /* armMs (2026-09-17): the game ignores taps for this long after it appears (900 on open,
     500 on a replay) while the pearl fades in and a thin ring pulses once, so a scroll
     that lands on the popup never drops a pearl. Only a clean tap drops (pointer down to
     up under 10px and 300ms; a touchmove cancels). A miss on the first drop within 2s of
     arming respawns silently, once a run. */
  function pearlsStart(armMs) {
    var st = $('[data-pearls]'), cv = st && $('[data-pearlcv]', st);
    if (!cv || !cv.getContext) return;
    pearlsStop();
    var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ctx = cv.getContext('2d'), W = 300, H = 320, PR = 15, BASE = { x: 150, y: 288, w: 46 }, MAXN = 6;
    var ARM = armMs == null ? 900 : armMs, now = function () { return (window.performance && performance.now) ? performance.now() : Date.now(); };
    var g = pearls = { raf: 0, live: true, stack: [], cur: null, fall: null, t: 0, over: false, msg: '', msgT: 0, read: { v: CFG.firstOrderPct || 10, to: CFG.firstOrderPct || 10, pop: 0 }, chain: 0, sparks: [], armAt: now() + ARM, armed: false, ring: -1, retried: false };
    var ink = getComputedStyle(document.documentElement).getPropertyValue('--text').trim() || '#141210';
    function units(n) { return playTier(n).pct; }
    function label(n) { return n >= 6 ? 'necklace complete' : n ? '+5% a pearl' : 'tap to drop'; }
    function size() { var b = cv.getBoundingClientRect(); if (!b.width) return false; var dpr = Math.min(2, window.devicePixelRatio || 1); cv.width = Math.round(b.width * dpr); cv.height = Math.round(b.height * dpr); ctx.setTransform(dpr * b.width / W, 0, 0, dpr * b.height / H, 0, 0); return true; }
    function topY() { return BASE.y - 8 - g.stack.length * PR * 2; }
    function pearl(x, y, a, sq) { ctx.save(); ctx.globalAlpha = a == null ? 1 : a; if (sq) { ctx.translate(x, y + PR); ctx.scale(1 + sq, 1 - sq); ctx.translate(-x, -(y + PR)); } ctx.beginPath(); ctx.arc(x, y + 3, PR, 0, 7); ctx.fillStyle = 'rgba(20,18,16,.14)'; ctx.fill(); var gr = ctx.createRadialGradient(x - 5, y - 6, 2, x, y, PR); gr.addColorStop(0, '#FFFFFF'); gr.addColorStop(.5, '#F1ECE2'); gr.addColorStop(1, '#CFC6B6'); ctx.beginPath(); ctx.arc(x, y, PR, 0, 7); ctx.fillStyle = gr; ctx.fill(); ctx.beginPath(); ctx.arc(x - 4, y - 5, 3, 0, 7); ctx.fillStyle = 'rgba(255,255,255,.9)'; ctx.fill(); ctx.restore(); }
    function spawn() { g.cur = { x: 150, y: 42, ph: 0, sp: .028 + g.stack.length * .009, vy: 0, drop: false }; }
    function strand(side, frac, gold) { var sx = side < 0 ? 14 : W - 14; ctx.beginPath(); ctx.moveTo(sx, -4); var N = 24; for (var i = 1; i <= Math.round(N * frac); i++) { var p = i / N, x = sx + (BASE.x - sx) * p * p, y = -4 + (BASE.y + 4) * Math.sin(p * Math.PI / 2); ctx.lineTo(x, y); } ctx.strokeStyle = gold ? '#C9A24A' : 'rgba(20,18,16,.16)'; ctx.lineWidth = gold ? 2.2 : 1.2; ctx.setLineDash(gold ? [] : [2, 4]); ctx.stroke(); ctx.setLineDash([]); }
    function draw() {
      ctx.clearRect(0, 0, W, H);
      strand(-1, 1, false); strand(1, 1, false); if (g.chain > 0) { strand(-1, g.chain, true); strand(1, g.chain, true); }
      ctx.strokeStyle = 'rgba(20,18,16,.12)'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(150, 0); ctx.lineTo(150, 42); ctx.stroke();
      var gr = ctx.createLinearGradient(BASE.x - 20, BASE.y, BASE.x + 20, BASE.y + 20); gr.addColorStop(0, '#F3E9C8'); gr.addColorStop(.5, '#C9A24A'); gr.addColorStop(1, '#8E6E22'); ctx.fillStyle = gr; ctx.beginPath(); ctx.moveTo(BASE.x - BASE.w / 2, BASE.y); ctx.lineTo(BASE.x + BASE.w / 2, BASE.y); ctx.lineTo(BASE.x, BASE.y + 22); ctx.closePath(); ctx.fill();
      g.stack.forEach(function (p) { var sq = p.s < 18 ? .16 * Math.sin(p.s / 18 * Math.PI) * Math.exp(-p.s / 9) : 0; pearl(p.x, p.y, 1, sq); if (p.s < 400) p.s++; });
      for (var i = g.stack.length; i < MAXN; i++) { ctx.beginPath(); ctx.arc(150, BASE.y - 8 - i * PR * 2, PR, 0, 7); ctx.strokeStyle = 'rgba(20,18,16,' + (i === g.stack.length ? '.35' : '.1') + ')'; ctx.setLineDash([2, 4]); ctx.stroke(); ctx.setLineDash([]); }
      if (g.cur) {
        pearl(g.cur.x, g.cur.y, g.armed ? 1 : Math.max(0, Math.min(1, 1 - (g.armAt - now()) / Math.max(1, ARM))));
        if (g.ring >= 0 && g.ring < 26) { ctx.save(); ctx.globalAlpha = .7 * (1 - g.ring / 26); ctx.strokeStyle = ink; ctx.lineWidth = 1; ctx.beginPath(); ctx.arc(g.cur.x, g.cur.y, PR + 3 + g.ring * .7, 0, 7); ctx.stroke(); ctx.restore(); g.ring++; }
      }
      if (g.fall) pearl(g.fall.x, g.fall.y, Math.max(0, 1 - g.fall.t / 40));
      g.sparks.forEach(function (s) { s.t++; s.x += s.vx; s.y += s.vy; s.vy += .08; ctx.globalAlpha = Math.max(0, 1 - s.t / 26); ctx.fillStyle = '#C9A24A'; ctx.beginPath(); ctx.arc(s.x, s.y, 1.6, 0, 7); ctx.fill(); ctx.globalAlpha = 1; }); g.sparks = g.sparks.filter(function (s) { return s.t < 26; });
      g.read.v += (g.read.to - g.read.v) * .18; if (g.read.pop > 0) g.read.pop--; var sc = 1 + .22 * Math.sin(g.read.pop / 14 * Math.PI);
      ctx.save(); ctx.translate(16, 88); ctx.scale(sc, sc); ctx.fillStyle = ink; ctx.font = '400 34px Cormorant, "Cormorant Garamond", Georgia, serif'; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic'; ctx.fillText(Math.round(g.read.v) + '%', 0, 0); ctx.restore();
      ctx.fillStyle = 'rgba(20,18,16,.62)'; ctx.font = '500 8px ui-monospace, Menlo, monospace'; ctx.textAlign = 'left'; ctx.fillText(label(g.stack.length).toUpperCase().split('').join(' '), 16, 104);
      ctx.fillStyle = ink; ctx.font = '500 9px ui-monospace, Menlo, monospace'; ctx.textAlign = 'right'; ctx.fillText(g.stack.length + ' / ' + MAXN, W - 14, 18);
      if (g.msgT > 0) { ctx.textAlign = 'center'; ctx.fillStyle = 'rgba(20,18,16,.75)'; ctx.fillText(g.msg, 150, H - 14); g.msgT--; }
    }
    function landed() { var n = g.stack.length; g.read.to = units(n); g.read.pop = 14; g.chain = n / MAXN; var p = g.stack[n - 1]; for (var i = 0; i < 8; i++) g.sparks.push({ x: p.x, y: p.y, vx: (Math.random() * 200 - 100) / 60, vy: -(Math.random() * 100) / 60 - .6, t: 0 }); g.msg = n >= 6 ? 'N E C K L A C E  C O M P L E T E' : units(n) > (CFG.firstOrderPct || 10) ? '+ 5 %  ·  ' + units(n) + ' %' : units(n) + ' %  F L O O R'; g.msgT = 60; }
    function finish() {
      if (g.over) return; g.over = true;
      keepBestPlay(playTier(g.stack.length));
      draw();
      if (replaysLeft() > 0) playButtons(true);
      else setTimeout(function () { if (pearls === g && state.ov.email) acceptPlay(); }, 1500);
    }
    function tick() {
      g.t++;
      if (!g.armed && now() >= g.armAt) { g.armed = true; g.ring = 0; }
      if (g.cur && !g.over) {
        if (!g.cur.drop) { g.cur.ph += g.cur.sp; g.cur.x = REDUCED ? 150 + (Math.round(g.t / 40) % 3 - 1) * 60 : 150 + 108 * Math.sin(g.cur.ph); }
        else {
          g.cur.vy += .55; g.cur.y += g.cur.vy; var ty = topY();
          if (g.cur.y + PR >= ty - PR) {
            var tx = g.stack.length ? g.stack[g.stack.length - 1].x : BASE.x, tol = g.stack.length ? PR * 2 * .72 : BASE.w / 2 + 4;
            if (Math.abs(g.cur.x - tx) <= tol) { g.stack.push({ x: g.cur.x, y: ty - PR, s: 0 }); g.cur = null; landed(); if (g.stack.length >= MAXN) setTimeout(finish, 500); else spawn(); }
            else if (!g.stack.length && !g.retried && (g.cur.at || 0) - g.armAt < 2000) { g.retried = true; g.fall = { x: g.cur.x, y: g.cur.y, vx: g.cur.x > tx ? 2 : -2, vy: 0, t: 0 }; g.cur = null; setTimeout(function () { if (pearls === g && !g.over && !g.cur) spawn(); }, 600); }
            else { g.fall = { x: g.cur.x, y: g.cur.y, vx: g.cur.x > tx ? 2 : -2, vy: 0, t: 0 }; g.cur = null; g.msg = 'A  G A P  ·  S T O P S  A T  ' + units(g.stack.length) + ' %'; g.msgT = 90; setTimeout(finish, 700); }
          }
        }
      }
      if (g.fall) { g.fall.t++; g.fall.x += g.fall.vx; g.fall.vy += .5; g.fall.y += g.fall.vy; if (g.fall.t > 60) g.fall = null; }
      draw(); if (g.live) g.raf = requestAnimationFrame(tick);
    }
    function tap() { if (g.over || !g.cur || g.cur.drop || !g.armed) return; g.cur.drop = true; g.cur.at = now(); }
    if (!cv.getAttribute('data-pearls-wired')) {
      cv.setAttribute('data-pearls-wired', '1');
      var pd = null;
      cv.addEventListener('pointerdown', function (e) { e.preventDefault(); pd = (pearls && pearls.armed) ? { x: e.clientX, y: e.clientY, t: now(), moved: false } : null; });
      cv.addEventListener('pointermove', function (e) { if (pd && Math.hypot(e.clientX - pd.x, e.clientY - pd.y) >= 10) pd.moved = true; });
      cv.addEventListener('touchmove', function () { if (pd) pd.moved = true; }, { passive: true });
      cv.addEventListener('pointercancel', function () { pd = null; });
      cv.addEventListener('pointerup', function (e) { var d = pd; pd = null; if (!d || d.moved || now() - d.t >= 300 || Math.hypot(e.clientX - d.x, e.clientY - d.y) >= 10) return; if (pearls) pearls.tap(); });
    }
    g.tap = tap;
    g.place = function () { if (g.cur && !g.cur.drop) { g.cur.x = g.stack.length ? g.stack[g.stack.length - 1].x : 150; g.cur.drop = true; g.cur.at = now(); } };
    g.miss = function () { if (g.cur && !g.cur.drop) { g.cur.x = (g.stack.length ? g.stack[g.stack.length - 1].x : 150) + 60; g.cur.drop = true; g.cur.at = now(); } };
    spawn();
    // the panel may still be mid fade-in with a 0-wide canvas: retry sizing for a few frames
    var tries = 0; (function go() { if (size()) { g.raf = requestAnimationFrame(tick); } else if (tries++ < 30 && g.live) requestAnimationFrame(go); })();
  }
  /* popup-v2 2026-09-17: step 2 keeps the necklace as a 120px strip, the pearls that landed
     drawn in place (static, redrawn from the saved count so a resumed step 2 shows it too). */
  function pearlsStrip(n) {
    var st = $('[data-pearls-strip]'), cv = st && $('[data-pearlcv-strip]', st);
    if (!cv || !cv.getContext) return;
    var tries = 0;
    (function go() {
      var b = cv.getBoundingClientRect();
      if (!b.width) { if (tries++ < 30) requestAnimationFrame(go); return; }
      var ctx = cv.getContext('2d'), dpr = Math.min(2, window.devicePixelRatio || 1), H = 120, s = b.height / H, W = b.width / s;
      cv.width = Math.round(b.width * dpr); cv.height = Math.round(b.height * dpr);
      ctx.setTransform(dpr * s, 0, 0, dpr * s, 0, 0); ctx.clearRect(0, 0, W, H);
      var PR = 8, cx = W * .66, by = 104, MAXN = 6, gold = n / MAXN;
      function strand(side, frac, isGold) { var sx = cx + side * Math.min(96, W * .3); ctx.beginPath(); ctx.moveTo(sx, -4); var N = 24; for (var i = 1; i <= Math.round(N * frac); i++) { var p = i / N; ctx.lineTo(sx + (cx - sx) * p * p, -4 + (by + 4) * Math.sin(p * Math.PI / 2)); } ctx.strokeStyle = isGold ? '#C9A24A' : 'rgba(20,18,16,.16)'; ctx.lineWidth = isGold ? 2 : 1; ctx.setLineDash(isGold ? [] : [2, 4]); ctx.stroke(); ctx.setLineDash([]); }
      strand(-1, 1, false); strand(1, 1, false); if (gold > 0) { strand(-1, gold, true); strand(1, gold, true); }
      var gr = ctx.createLinearGradient(cx - 10, by, cx + 10, by + 10); gr.addColorStop(0, '#F3E9C8'); gr.addColorStop(.5, '#C9A24A'); gr.addColorStop(1, '#8E6E22'); ctx.fillStyle = gr; ctx.beginPath(); ctx.moveTo(cx - 12, by); ctx.lineTo(cx + 12, by); ctx.lineTo(cx, by + 11); ctx.closePath(); ctx.fill();
      for (var i = 0; i < MAXN; i++) {
        var y = by - 5 - i * PR * 2;
        if (i < n) { ctx.beginPath(); ctx.arc(cx, y + 2, PR, 0, 7); ctx.fillStyle = 'rgba(20,18,16,.14)'; ctx.fill(); var g2 = ctx.createRadialGradient(cx - 3, y - 3, 1, cx, y, PR); g2.addColorStop(0, '#FFFFFF'); g2.addColorStop(.5, '#F1ECE2'); g2.addColorStop(1, '#CFC6B6'); ctx.beginPath(); ctx.arc(cx, y, PR, 0, 7); ctx.fillStyle = g2; ctx.fill(); }
        else { ctx.beginPath(); ctx.arc(cx, y, PR, 0, 7); ctx.strokeStyle = 'rgba(20,18,16,.12)'; ctx.setLineDash([2, 4]); ctx.stroke(); ctx.setLineDash([]); }
      }
    })();
  }
  window.h13Pearls = { place: function () { pearls && pearls.place(); }, miss: function () { pearls && pearls.miss(); }, tap: function () { pearls && pearls.tap(); }, replay: replayPlay, state: function () { return pearls ? { n: pearls.stack.length, over: pearls.over, armed: pearls.armed, retried: pearls.retried, best: emailState.play || null, replaysLeft: replaysLeft() } : null; } };
  function submitEmail() {
    var input = $('[data-email-input]');
    if (!input) return;
    if (!/.+@.+\..+/.test(input.value)) { input.focus(); return; }
    emailState.email = input.value.trim(); saveEmailState();
    submitCapture(EMAIL_DONE);
  }
  function dismissEmail() {
    pearlsStop();
    if (emailStep < EMAIL_DONE) {
      try { localStorage.setItem('h13v2_email_dismissed', String(Date.now())); } catch (e) {}
    }
    closeOv('email');
  }
  function reopenEmail() {
    healDiscountCookie();
    setEmailStep(discountActive() ? EMAIL_DONE : (emailState.step || 0));
    openOv('email');
  }
  function submitNews(form) {
    if (!form.reportValidity()) return false;
    form.setAttribute('data-h13-native', '1');
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
    return false;
  }
  function showNewsDone(form) {
    var idle = $('[data-news-idle]', form);
    if (idle) idle.hidden = true;
    $$('[data-news-done]', form).forEach(function (el) { el.hidden = false; });
  }

  /* ---------- complete-the-set sheet ---------- */
  var setChoice = 'single';
  function sheetData() {
    var el = $('[data-set-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  // best bundle this product can actually offer — guards products with no companions,
  // whose pair/set entries carry no variant ids
  function bestSetChoice() {
    var data = sheetData();
    if (!data) return 'single';
    var ok = function (k) {
      return data[k] && data[k].variants && data[k].variants.length &&
             data[k].variants.every(function (id) { return !!id; });
    };
    if (ok('pair')) return 'pair';
    return 'single';
  }
  function pickSetChoice(choice) {
    setChoice = choice;
    var sheet = ovEl('set');
    if (!sheet) return;
    $$('[data-set-choice]', sheet).forEach(function (btn) {
      var a = btn.getAttribute('data-set-choice') === choice;
      btn.style.background = a ? 'var(--surface)' : 'transparent';
      btn.style.borderColor = a ? 'var(--text)' : 'var(--hairline)';
      var dot = $('[data-dot]', btn);
      if (dot) dot.style.background = a ? 'var(--text)' : 'transparent';
    });
    var data = sheetData();
    var btnAdd = $('[data-set-add]', sheet);
    if (data && data[choice] && btnAdd) {
      // name what is being added and show the saving — "ADD SELECTED" told the shopper
      // nothing about which of the three options they were about to buy
      var label = choice === 'single' ? 'ADD THIS PIECE' : (choice === 'pair' ? 'ADD THE PAIR' : 'ADD THE SET');
      var txt = label + ' — ' + fmt(data[choice].price);
      var full = data.single && data[choice].full;
      if (full && full > data[choice].price) txt += ' · SAVE ' + fmt(full - data[choice].price);
      btnAdd.textContent = txt;
    }
  }

  /* ---------- art-directed per-viewport media ---------- */
  // Pause videos inside hidden .h13-mq-m/.h13-mq-d variant containers, play visible
  // ones. Runs at boot, on the 768px breakpoint change, and after hero slide advances.
  // Safe no-op on pages without variant containers (e.g. PDP, incl. after swipe swaps).
  /* Variant videos are rendered without autoplay and with preload="none" (see
     snippets/responsive-media.liquid): a desktop-only hero video used to download in
     full on every phone — three of them, 13.8 MB, before a single product image — with
     autoplay forcing the fetch even inside display:none. The visible variant is
     switched to preload=auto and played here; hidden ones stay cold. */
  // Inside the home hero only the slide on screen plays; the next one warms its buffer
  // (preload=auto) so the advance is seamless; the rest stay cold. Desktop used to pull
  // all three hero videos (13.8 MB) the moment the page opened.
  function heroSlideState(slide) {
    if (slide.hasAttribute('data-hero-clone')) return 'cold';
    var track = slide.parentNode;
    var slides = Array.prototype.slice.call(track.children).filter(function (el) { return getComputedStyle(el).display !== 'none'; });
    var w = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : (slides[0] ? slides[0].offsetWidth : 0);
    if (!(w > 0)) w = track.clientWidth || 1;
    var cur = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    var i = slides.indexOf(slide);
    if (i === cur) return 'current';
    if (slides.length > 1 && i === (cur + 1) % slides.length) return 'next';
    return 'cold';
  }
  /* playVideo(): the visible slide's <video> ships preload="none" + poster. Why play() used
     to hang on it: (1) preload=none leaves networkState EMPTY, and a play() issued before
     the resource selection has run resolves only once data arrives; a pause() from the next
     syncViewportMedia pass (scroll debounce, goTo) landed in that gap and aborted it, so the
     video sat on its poster; (2) with the pending play cancelled nothing ever retried. Now:
     preload flips to auto and load() runs when the element has no data yet, muted/inline
     are asserted as properties (autoplay policy), a pending play is never interrupted by a
     pause, and a NotAllowedError retries on the first touch. */
  function playVideo(v) {
    if (!v || v.__h13Pending) { if (v) v.__h13Want = 'play'; return; }
    v.__h13Want = 'play';
    if (v.preload !== 'auto') v.preload = 'auto';
    v.muted = true; v.defaultMuted = true; v.setAttribute('playsinline', '');
    if (v.networkState === 0 /* NETWORK_EMPTY */ || (v.readyState === 0 && v.networkState === 1)) { try { v.load(); } catch (e) {} }
    if (!v.paused) return;
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (!p || !p.then) return;
    v.__h13Pending = true;
    p.then(function () { v.__h13Pending = false; if (v.__h13Want === 'pause') v.pause(); }, function (err) {
      v.__h13Pending = false;
      if (v.__h13Want !== 'play') return;
      if (err && err.name === 'NotAllowedError' && !v.__h13Retry) {
        v.__h13Retry = true;
        var once = function () { document.removeEventListener('touchstart', once); document.removeEventListener('pointerdown', once); if (v.__h13Want === 'play') playVideo(v); };
        document.addEventListener('touchstart', once, { passive: true });
        document.addEventListener('pointerdown', once, { passive: true });
      } else if (err && err.name === 'AbortError') {
        setTimeout(function () { if (v.__h13Want === 'play' && v.paused) playVideo(v); }, 200);
      }
    });
  }
  function pauseVideo(v) {
    v.__h13Want = 'pause';
    if (v.__h13Pending) return; // let the pending play settle, then pause (see playVideo)
    if (!v.paused) { try { v.pause(); } catch (e) {} }
  }
  function syncViewportMedia() {
    $$('.h13-mq-m, .h13-mq-d').forEach(function (box) {
      var vids = $$('video', box);
      if (!vids.length) return;
      var show = getComputedStyle(box).display !== 'none';
      var slide = box.closest ? box.closest('[data-hero-slide]') : null;
      var role = show && slide ? heroSlideState(slide) : (show ? 'current' : 'cold');
      vids.forEach(function (v) {
        try {
          if (role === 'current') {
            playVideo(v);
          } else if (role === 'next') {
            if (v.preload !== 'auto') v.preload = 'auto'; // warm the buffer, no playback
            pauseVideo(v);
          } else {
            pauseVideo(v); // cold slides keep preload="none"
          }
        } catch (e) {}
      });
    });
  }

  /* One quiet retry for any image that fails to load — a dropped cellular packet or
     a CDN hiccup used to leave a broken-image glyph in the grid until reload (Adam's
     2026-08-19 screenshot, Eclipse Mesh Bracelet). The retry re-requests the same
     rendition with a cache-busting param; a second failure is left alone. */
  document.addEventListener('error', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG' || img.getAttribute('data-h13-retried')) return;
    var src = img.getAttribute('src');
    if (!src || !/\/cdn\/shop\//.test(src)) return;
    img.setAttribute('data-h13-retried', '1');
    setTimeout(function () {
      var bust = function (u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'h13r=1'; };
      var ss = img.getAttribute('srcset');
      if (ss) img.setAttribute('srcset', ss.split(',').map(function (part) { var bits = part.trim().split(/\s+/); bits[0] = bust(bits[0]); return bits.join(' '); }).join(', '));
      img.setAttribute('src', bust(src));
    }, 1200);
  }, true);

  /* ---------- reveals (IntersectionObserver + CSS, 2026-09-03) ----------
     Was GSAP + ScrollTrigger (113 KB) for a single fade-and-rise. Same motion, same
     trigger point (GSAP's start:'top 90%' == rootMargin bottom -10%), same once-only
     behaviour, zero dependencies. CSS holds the states (h13-base.css, [data-reveal]).
     A safety timer reveals anything still hidden after 3s so a missed observer can
     never leave a block invisible. */
  var revealIO = null;
  function revealNow(el) { el.classList.add('is-in'); }
  function initReveals() {
    var els = $$('[data-reveal]').filter(function (el) {
      return !el.getAttribute('data-h13-revealed') && !(el.closest && el.closest('[data-swipe-panel]'));
    });
    if (!els.length) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { els.forEach(revealNow); return; }
    if (typeof IntersectionObserver === 'undefined') { els.forEach(revealNow); return; }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          revealIO.unobserve(en.target);
          revealNow(en.target);
        });
      }, { rootMargin: '0px 0px -10% 0px' });
    }
    els.forEach(function (el) {
      el.setAttribute('data-h13-revealed', '1');
      revealIO.observe(el);
      setTimeout(function () { if (!el.classList.contains('is-in')) revealNow(el); }, 3000);
    });
  }

  /* ---------- product grids: reveal each card WITH its image; load pages as you scroll ----------
     A card is invisible (CSS, html.h13-js) until it is near the viewport and its image has
     decoded — so image and card land together instead of an empty box that fills in late.
     Collections carry data-infinite: when the shopper is ~1.5 screens from the end, the
     next paginated page is fetched through the Section Rendering API and its cards are
     appended (and revealed the same way). The .h13-pager link stays in the DOM. */
  var cardIO = null;
  function revealCard(card) { card.classList.add('is-in'); }
  function cardNear(card) {
    var img = $('img', card);
    var shown = false;
    var done = function () { if (shown) return; shown = true; revealCard(card); };
    if (!img || img.complete) {
      if (img && img.complete && img.naturalWidth && img.decode) img.decode().then(done, done); else done();
      return;
    }
    var cap = setTimeout(done, 2500); // a slow image never leaves a hole in the grid
    img.addEventListener('load', function () {
      clearTimeout(cap);
      if (img.decode) img.decode().then(done, done); else done();
    }, { once: true });
    img.addEventListener('error', function () { clearTimeout(cap); done(); }, { once: true });
  }
  function initCardReveal() {
    var cards = $$('.h13-grid .h13-card').filter(function (c) {
      return !c.getAttribute('data-h13-seen') && !(c.closest && c.closest('[data-swipe-panel]'));
    });
    if (!cards.length) return;
    if (typeof IntersectionObserver === 'undefined') { cards.forEach(revealCard); return; }
    if (!cardIO) {
      cardIO = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          cardIO.unobserve(en.target);
          cardNear(en.target);
        });
      }, { rootMargin: '30% 0px' });
    }
    cards.forEach(function (c) { c.setAttribute('data-h13-seen', '1'); cardIO.observe(c); });
  }
  function initInfiniteGrid() {
    var grid = $('.h13-grid[data-infinite]');
    if (!grid || grid.getAttribute('data-h13-infinite') || typeof IntersectionObserver === 'undefined') return;
    var pager = $('.h13-pager');
    var next = pager && $('a[rel="next"]', pager);
    if (!next) return;
    grid.setAttribute('data-h13-infinite', '1');
    var sid = grid.getAttribute('data-section-id') || '';
    var url = next.getAttribute('href');
    var busy = false;
    var sentinel = document.createElement('div');
    sentinel.setAttribute('data-grid-sentinel', '');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:1px;margin-top:-1px';
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);
    pager.classList.add('h13-pager--js');
    var io = new IntersectionObserver(function (es) {
      if (!es.some(function (en) { return en.isIntersecting; })) return;
      loadMore();
    }, { rootMargin: '1200px 0px' });
    function finish() { io.disconnect(); if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel); }
    function loadMore() {
      if (busy || !url) return;
      busy = true;
      var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
      fetch(u)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('.h13-grid');
          if (!g) { url = null; finish(); return; }
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(g.children).forEach(function (c) { frag.appendChild(c); });
          grid.appendChild(frag);
          initCardReveal();
          var n = doc.querySelector('.h13-pager a[rel="next"]');
          url = n ? n.getAttribute('href') : null;
          if (url) next.setAttribute('href', url); else { finish(); pager.hidden = true; } // last page is in
          busy = false;
        })
        .catch(function () {
          // network hiccup: hand back the plain pager so the shopper can still go on
          busy = false; url = null; finish();
          pager.classList.remove('h13-pager--js');
        });
    }
    io.observe(sentinel);
  }

  /* ---------- prototype controls ---------- */
  function applyTheme(t) {
    if (root) root.setAttribute('data-theme', t);
    document.body.style.background = t === 'dark' ? '#0A0908' : '#F4F1EA';
    document.documentElement.setAttribute('data-h13-theme', t);
    try { localStorage.setItem('h13v2_theme', t); } catch (e) {}
    syncProtoButtons();
  }
  function currentTheme() {
    return (root && root.getAttribute('data-theme')) || CFG.colorScheme || 'light';
  }
  function syncProtoButtons() {
    var t = currentTheme();
    var gridEl = $('[data-grid-overlay]');
    var gridOn = gridEl ? !gridEl.hidden : false;
    $$('[data-proto]').forEach(function (btn) {
      var kind = btn.getAttribute('data-proto');
      var active = kind === 'grid' ? gridOn : kind === t;
      btn.style.background = active ? 'var(--text)' : 'transparent';
      btn.style.color = active ? 'var(--bg)' : 'var(--muted)';
    });
  }

  /* ---------- predictive search ---------- */
  var searchSeq = 0;
  var searchDebounce = null;
  function runSearch(q) {
    var idle = $('[data-search-idle]');
    var results = $('[data-search-results]');
    if (!results) return;
    q = q.trim();
    if (!q) {
      if (idle) idle.hidden = false;
      results.hidden = true;
      results.innerHTML = '';
      return;
    }
    var seq = ++searchSeq;
    fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=predictive-search')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (seq !== searchSeq) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section') || tmp.firstElementChild;
        results.innerHTML = inner ? inner.innerHTML : html;
        var cards = results.querySelectorAll('[data-denim-card]'), found = 0;
        cards.forEach(function(card){var show=(card.getAttribute('data-denim-search')||'').indexOf(q.toLowerCase())!==-1;card.hidden=!show;if(show)found++;});
        if(!found) results.innerHTML='<p>No matching style.</p><a href="/collections/all" class="h13-btn">Explore all denim</a>'; 
        if (idle) idle.hidden = true;
        results.hidden = false;
      })
      .catch(function () {});
  }

  /* ---------- PDP page-scoped wiring (re-run after swipe swaps) ---------- */
  var pdpObservers = [];
  var desktopMQ = window.matchMedia ? matchMedia('(min-width: 768px)') : null;
  var mobileMQ = window.matchMedia ? matchMedia('(max-width: 767px)') : null;
  var motionReduced = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;

  function pdpScope() {
    var s = $('.h13-pdp');
    return s ? (s.closest('.shopify-section') || s) : null;
  }
  function trackIO(o) { pdpObservers.push(o); return o; }
  function syncBarNow() {
    var scope = pdpScope();
    if (!scope) return;
    var pb = $('[data-purchase-block]', scope);
    var bar = $('[data-sticky-bar]', scope);
    if (!pb || !bar) return;
    bar.hidden = !(pb.getBoundingClientRect().bottom < 0);
  }
  /* ---------- PDP variants (2026-09-15): [data-variant-option] radio pills + [data-variant-map] ----------
     On change the checked option1..3 values are matched to a variant; every [data-pdp-add]
     (main CTA + sticky bar) gets its id, [data-pdp-price] re-renders, and pills whose
     variant (with the other options as chosen) is unavailable are marked data-unavailable. */
  function pdpVariants() {
    var scope = pdpScope() || document;
    var mapEl = $('[data-variant-map]', scope);
    if (!mapEl) return null;
    try { return JSON.parse(mapEl.textContent || '[]'); } catch (e) { return null; }
  }
  function pdpMoney(cents) {
    var cur = (document.documentElement.getAttribute('data-currency') || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD');
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return fmt(cents); }
  }
  function pdpVariantSync(changed) {
    var scope = pdpScope() || document;
    var variants = pdpVariants();
    if (!variants || !variants.length) return;
    var chosen = [1, 2, 3].map(function (i) { var r = $('[data-variant-option][name="option' + i + '"]:checked', scope); return r ? r.value : null; });
    var match = variants.filter(function (v) { return [1, 2, 3].every(function (i) { return chosen[i - 1] === null || v['option' + i] === chosen[i - 1]; }); })[0];
    // an unavailable landing: fall back to the first available variant for that first option
    if (!match && changed) { match = variants.filter(function (v) { return v.option1 === chosen[0]; })[0]; }
    if (match) {
      $$('[data-pdp-add]', scope).forEach(function (b) {
        b.setAttribute('data-add-variant', match.id);
        b.disabled = !match.available;
        b.style.opacity = match.available ? '' : '.45';
        if (!match.available) b.textContent = 'Sold out'; else if (/^sold out$/i.test(b.textContent.trim())) b.textContent = 'Add to bag';
      });
      var price = $('[data-pdp-price]', scope);
      if (price) {
        var onSale = match.compare_at_price && match.compare_at_price > match.price;
        var html = '<span class="h13-pdp-price-now' + (onSale ? ' is-sale' : '') + '">' + pdpMoney(match.price) + '</span>';
        if (onSale) html += '<span class="h13-pdp-price-was">' + pdpMoney(match.compare_at_price) + '</span><span class="h13-pdp-price-pct">\u2212' + Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price) + '%</span>';
        price.innerHTML = html;
      }
      [1, 2, 3].forEach(function (i) { var o = $('[data-variant-option-value="' + i + '"]', scope); if (o && match['option' + i]) o.textContent = String(match['option' + i]).replace(/^2XL$/, 'XXL').replace(/^3XL$/, 'XXXL'); });
    }
    // availability per pill, given the other options as currently chosen
    $$('[data-variant-option]', scope).forEach(function (r) {
      var i = parseInt((r.name || '').replace('option', ''), 10);
      var ok = variants.some(function (v) {
        if (!v.available || v['option' + i] !== r.value) return false;
        return [1, 2, 3].every(function (j) { return j === i || chosen[j - 1] === null || v['option' + j] === chosen[j - 1]; });
      });
      var lab = r.closest('label') || r;
      if (ok) lab.removeAttribute('data-unavailable'); else lab.setAttribute('data-unavailable', '');
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-variant-option]')) pdpVariantSync(true);
  });
  /* [data-pdp-nudge] (meter nudge under the price, carries data-product-price): after any cart
     add the PDP section is re-fetched via Section Rendering and the span's text swapped */
  function refreshPdpNudge() {
    var n = $('[data-pdp-nudge]');
    if (!n) return;
    var wrap = n.closest ? n.closest('[id^="shopify-section-"]') : null;
    var sid = wrap ? wrap.id.replace('shopify-section-', '') : 'main-product';
    fetch(location.pathname + '?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-pdp-nudge]');
        var cur = $('[data-pdp-nudge]');
        if (fresh && cur) { cur.textContent = fresh.textContent; if (fresh.getAttribute('data-product-price')) cur.setAttribute('data-product-price', fresh.getAttribute('data-product-price')); }
      })
      .catch(function () {});
  }
  function initPdpScoped() {
    pdpObservers.forEach(function (o) { try { o.disconnect(); } catch (e) {} });
    pdpObservers = [];
    var scope = pdpScope();
    if (!scope) return;

    // mobile hero flip-through carousel: counter + scroll reset (re-inits after swaps)
    var heroScroll = $('[data-pdp-hero-scroll]', scope);
    var heroCounter = $('[data-pdp-hero-counter]', scope);
    var heroDots = $$('[data-pdp-hero-dots] i', scope);
    if (heroScroll && (heroCounter || heroDots.length)) {
      var htotal = parseInt(heroCounter ? heroCounter.getAttribute('data-total') : '', 10) || heroDots.length || heroScroll.children.length;
      heroScroll.scrollLeft = 0;
      if (heroCounter) heroCounter.textContent = '1 / ' + htotal;
      heroScroll.addEventListener('scroll', function () {
        var i = Math.min(htotal, Math.max(1, Math.round(heroScroll.scrollLeft / heroScroll.clientWidth) + 1));
        if (heroCounter) heroCounter.textContent = i + ' / ' + htotal;
        heroDots.forEach(function (d, k) { d.classList.toggle('is-on', k === i - 1); });
      }, { passive: true });
    }

    // media counter over the stacked slides (visible on desktop only)
    var counter = $('[data-car-counter]', scope);
    if (counter && desktopMQ && typeof IntersectionObserver !== 'undefined') {
      var total = parseInt(counter.getAttribute('data-car-total'), 10) || 5;
      var slides = $$('[data-pdp-slide]', scope);
      var slideIO = trackIO(new IntersectionObserver(function (es) {
        if (!desktopMQ.matches) return;
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = slides.indexOf(en.target);
          if (i > -1) counter.textContent = (i + 1) + ' / ' + total;
        });
      }, { threshold: 0.5 }));
      slides.forEach(function (s) { slideIO.observe(s); });
    }

    // sticky add-to-bag bar (persists all the way down): watches the CTA button itself,
    // so the bar lands the moment the button leaves the viewport (2026-09-17)
    var pb = $('[data-purchase-block] [data-pdp-add]', scope) || $('[data-purchase-block]', scope);
    var bar = $('[data-sticky-bar]', scope);
    if (pb && bar && typeof IntersectionObserver !== 'undefined') {
      trackIO(new IntersectionObserver(function (es) {
        var en = es[0];
        var on = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.hidden = !on;
      }, { threshold: 0 })).observe(pb);
    }

    // MORE FROM US incremental reveal
    var sentinel = $('[data-more-sentinel]', scope);
    if (sentinel && typeof IntersectionObserver !== 'undefined') {
      var shown = 10;
      trackIO(new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        shown = Math.min(shown + 10, 42);
        $$('.h13-more-card', scope).forEach(function (el, i) {
          if (i < shown) el.hidden = false;
        });
      }, { rootMargin: '420px 0px' })).observe(sentinel);
    }

    // adjacent strip: bring the active thumb into view
    var strip = $('[data-adj-strip]', scope);
    if (strip) {
      var act = $('[data-adj-active]', strip);
      if (act) strip.scrollLeft = Math.max(0, act.offsetLeft - (strip.clientWidth - act.offsetWidth) / 2);
    }

    pickSetChoice(bestSetChoice());
    initCardReveal();

    reserveCacheRefresh();
    reserveRender();
    pdpVariantSync(false);
    // each PDP view counts toward the email trigger
    try { sessionStorage.setItem('h13v2_pdp_opens', String(pdpOpens() + 1)); } catch (e) {}
    maybeEmail();

  }

  var pendingVariantAdds = Object.create(null);

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if (!e.target || !e.target.closest) return;

    // promo code: APPLY chip / remove × (bag summary + cart page)
    t = e.target.closest('[data-promo-apply]');
    if (t) { e.preventDefault(); promoApply(t.closest('[data-promo]')); return; }
    t = e.target.closest('[data-promo-remove]');
    if (t) { e.preventDefault(); promoRemove(t.closest('[data-promo]'), t.getAttribute('data-promo-remove')); return; }

    // add single variant (quick add, PDP, sticky bar, rails)
    t = e.target.closest('[data-add-variant]');
    if (t) {
      e.preventDefault();
      e.stopPropagation();
      var addId = parseInt(t.getAttribute('data-add-variant'), 10);
      if (t.disabled || pendingVariantAdds[addId] || !addId) return;
      pendingVariantAdds[addId] = true;
      t.disabled = true;
      t.setAttribute('aria-busy', 'true');
      var chainCard = t.closest('[data-chain-upsell]');
      var chainError = chainCard && chainCard.querySelector('[data-chain-error]');
      if (chainError) chainError.hidden = true;
      var added = cartAdd([{ id: addId, quantity: 1 }], t.hasAttribute('data-open-bag'));
      added.then(function (ok) {
        delete pendingVariantAdds[addId];
        if (t.isConnected) {
          t.disabled = false;
          t.removeAttribute('aria-busy');
          if (!ok && chainError) {
            chainError.textContent = t.getAttribute('data-add-error');
            chainError.hidden = false;
          }
        }
      });
      if (t.hasAttribute('data-add-morph')) {
        added.then(function (ok) {
          if (!ok || !t.isConnected) return;
          // morph only the glyph child so the card's "Add" label survives the first add
          var g = t.querySelector('[data-add-morph-glyph]') || t;
          g.textContent = '✓';
          setTimeout(function () { if (g.isConnected) g.textContent = '+'; }, 1200);
        });
      }
      if (t.hasAttribute('data-pdp-add') || (CFG.template === 'product' && !t.closest('[data-ov]'))) added.then(function (ok) { if (ok) refreshPdpNudge(); });
      return;
    }

    // add multiple variants (set cards, ADD SELECTED handled separately)
    t = e.target.closest('[data-add-variants]');
    if (t) {
      e.preventDefault();
      var items = t.getAttribute('data-add-variants').split(',').map(function (id) {
        return { id: parseInt(id, 10), quantity: 1 };
      });
      cartAdd(items, true);
      return;
    }

    // qty +/- and remove
    t = e.target.closest('[data-qty-delta]');
    if (t) {
      var key = t.getAttribute('data-line-key');
      var delta = t.getAttribute('data-qty-delta');
      if (delta === 'remove') cartChange(key, 0);
      else cartChange(key, Math.max(0, (parseInt(t.getAttribute('data-line-qty'), 10) || 0) + parseInt(delta, 10)));
      return;
    }

    // checkout — the drawer renders a real <a href="/checkout">; let it navigate natively.
    // Legacy <button data-checkout> (cart page) still goes through here.
    t = e.target.closest('[data-checkout]');
    if (t) {
      if (t.tagName === 'A') return;
      if (cartCount > 0) window.location.href = '/checkout';
      return;
    }

    // accordion toggle
    t = e.target.closest('[data-acc-toggle]');
    if (t) {
      var acc = t.closest('[data-acc]');
      var content = acc && $('[data-acc-content]', acc);
      var mark = $('[data-acc-mark]', t);
      if (content) {
        content.hidden = !content.hidden;
        if (mark) mark.textContent = content.hidden ? '+' : '−';
      }
      return;
    }

    // set sheet option pick / add
    t = e.target.closest('[data-set-choice]');
    if (t) { pickSetChoice(t.getAttribute('data-set-choice')); return; }
    t = e.target.closest('[data-set-add]');
    if (t) {
      var data = sheetData();
      if (data && data[setChoice]) {
        // close the sheet up front: if the add fails, the shopper must not be left
        // staring at an open sheet on a page that can no longer scroll
        closeOv('set');
        cartAdd(data[setChoice].variants.map(function (id) { return { id: id, quantity: 1 }; }), true);
      }
      return;
    }

    // email modal
    t = e.target.closest('[data-email-change]');
    if (t) {
      emailState.email = ''; emailState.step = 1; saveEmailState();
      var changeInput = $('[data-email-input]'); if (changeInput) changeInput.value = '';
      var changeForm = $('[data-email-form]'); if (changeForm) { changeForm.removeAttribute('data-h13-native'); changeForm.removeAttribute('data-h13-busy'); }
      setEmailStep(1); return;
    }
    t = e.target.closest('[data-email-intent]');
    if (t) { chooseIntent(t); return; }
    t = e.target.closest('[data-email-skip]');
    if (t) { skipPlay(); return; }
    t = e.target.closest('[data-play-again]');
    if (t) { replayPlay(); return; }
    t = e.target.closest('[data-email-submit]');
    if (t) { submitEmail(); return; }
    t = e.target.closest('[data-email-keep]');
    if (t) { closeOv('email'); return; }
    t = e.target.closest('[data-email-dismiss]');
    if (t) { dismissEmail(); return; }
    t = e.target.closest('[data-reopen-email]');
    if (t) { reopenEmail(); return; }

    // prototype controls
    t = e.target.closest('[data-proto]');
    if (t) {
      var kind = t.getAttribute('data-proto');
      if (kind === 'grid') {
        var g = $('[data-grid-overlay]');
        if (g) g.hidden = !g.hidden;
        syncProtoButtons();
      } else {
        applyTheme(kind);
      }
      return;
    }

    // generic overlay open/close (keep last: backdrops carry data-ov-close)
    t = e.target.closest('[data-open]');
    if (t) {
      var closeFirst = t.getAttribute('data-close-first');
      if (closeFirst) closeFirst.split(',').forEach(function (k) { state.ov[k.trim()] = false; });
      openOv(t.getAttribute('data-open'));
      return;
    }
    t = e.target.closest('[data-close]');
    if (t) { closeOv(t.getAttribute('data-close')); return; }
    t = e.target.closest('[data-ov-close]');
    if (t) { closeOv(t.getAttribute('data-ov-close')); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeTop(); return; }
    if (e.key !== 'Enter' || !e.target) return;
    if (e.target.matches && e.target.matches('[data-email-input]')) { e.preventDefault(); submitEmail(); }
    // search input now lives in a real GET form (action=/search, name=q):
    // Enter / mobile "go" submits natively, so no JS special-case is needed.
  });

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-news-form]') : null;
    if (form) {
      if (form.getAttribute('data-h13-native') === '1') return; // Shopify's captcha handler takes it from here
      e.preventDefault();
      submitNews(form);
      return;
    }
    var cap = e.target && e.target.closest ? e.target.closest('form[data-email-form]') : null;
    if (cap && cap.getAttribute('data-h13-native') !== '1') { e.preventDefault(); submitEmail(); }
  });

  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('[data-search-input]')) return;
    var q = e.target.value;
    clearTimeout(searchDebounce);
    searchDebounce = setTimeout(function () { runSearch(q); }, 150);
  });

  /* ---------- boot ---------- */

  /* ---------- exit-intent offer (2026-09-04) --------------------------------------
     Ily: "when you attempt to close the tab with something in your bag, it creates a
     popup offering an extra discount and confirming whether or not they want to
     navigate away."

     A page cannot draw its own UI at tab-close time. `beforeunload` is the only hook
     there, it renders a browser-written string, cannot be customised, and is ignored
     unless the visitor already interacted - so it can never carry an offer. This fires
     on exit INTENT instead, a beat earlier, while the page can still speak:

       desktop  the cursor leaves through the TOP edge (tab bar / close / address bar)
       mobile   the BACK gesture, trapped with a pushed history entry - there is no
                cursor on a phone, so back is the honest "I am leaving" signal

     Guards, because an unguarded version of this is the most hated pattern on the web:
     only with something in the bag, once per session, never on /cart or /checkout,
     never over another overlay, and silent for exit_offer_days after a dismissal. */
  var exitArmed = false, exitShown = false, exitBackTrap = false;

  function exitCfg() { return CFG.exitOffer || {}; }
  function exitSuppressed() {
    try {
      if (sessionStorage.getItem('h13_exit_seen') === '1') return true;
      var ts = +localStorage.getItem('h13_exit_dismissed') || 0;
      var days = exitCfg().days || 7;
      return !!ts && (Date.now() - ts) < days * 864e5;
    } catch (e) { return false; }
  }
  function exitEligible() {
    if (!exitCfg().enabled || exitShown) return false;
    if (!$('[data-ov="exit"]')) return false;
    if (cartCount < 1) return false;                       // Ily's condition: something in the bag
    // 2026-09-17 (Adam): never offer SECRET15 over a code that already beats it on the cart
    var exitPct = parseInt(exitCfg().pct, 10) || 15;
    var applied = promoApplied();
    for (var i = 0; i < applied.length; i++) {
      var m = /^PLAY(\d+)/i.exec(applied[i]); var have = m ? parseInt(m[1], 10) : (/^LIST/i.test(applied[i]) ? 10 : (/^SECRET(\d+)/i.exec(applied[i]) ? parseInt(/^SECRET(\d+)/i.exec(applied[i])[1], 10) : 0));
      if (have >= exitPct) return false;
    }
    if (CFG.template === 'cart') return false;             // already at the last step
    if (/^\/(cart|checkout)/.test(location.pathname)) return false;
    if (anyOv()) return false;                             // never stack on another overlay
    if (exitSuppressed()) return false;
    if (exitCooldown()) return false;                      // the newsletter modal closed in the last 10 minutes
    return true;
  }
  /* what is in the bag, painted right before the popup opens so it matches the live cart:
     up to 4 thumbnails + "3 pieces · $228". Reads the drawer's rendered rows when they are
     on the page (one [data-qty-delta="remove"] per line; its row holds the line image, and
     [data-bag-subtotal] carries count + formatted total), else asks /cart.js. */
  function exitFillBag() {
    var wrap = $('[data-exit-items]'), sum = $('[data-exit-summary]');
    if (!wrap && !sum) return;
    var paint = function (thumbs, count, total) {
      if (wrap) {
        wrap.innerHTML = '';
        thumbs.slice(0, 4).forEach(function (src) {
          var img = document.createElement('img');
          img.src = src; img.alt = ''; img.width = 36; img.height = 36;
          img.style.cssText = 'width:36px;height:36px;border-radius:8px;object-fit:cover;background:var(--placeholder);flex:none';
          wrap.appendChild(img);
        });
        wrap.hidden = !thumbs.length;
      }
      if (sum) sum.textContent = count ? count + (count === 1 ? ' piece' : ' pieces') + (total ? ' \u00b7 ' + total : '') : '';
    };
    var removes = $$('[data-ov="bag"] [data-line-key][data-qty-delta="remove"]');
    var subEl = $('[data-ov="bag"] [data-bag-subtotal]');
    if (removes.length && subEl) {
      var thumbs = [];
      removes.forEach(function (b) {
        var row = b.parentElement && b.parentElement.parentElement;
        var img = row && row.querySelector('img');
        var src = img && (img.currentSrc || img.getAttribute('src'));
        if (src) thumbs.push(src);
      });
      var count = parseInt(subEl.getAttribute('data-count'), 10) || cartCount;
      var last = subEl.lastChild;
      var total = (last && last.nodeType === 3 ? last.textContent : subEl.textContent).trim();
      paint(thumbs, count, total);
      return;
    }
    paint([], cartCount, '');
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var thumbs = (c.items || []).map(function (i) { return i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=72' : ''; }).filter(Boolean);
        var total;
        try { total = new Intl.NumberFormat(undefined, { style: 'currency', currency: c.currency, maximumFractionDigits: c.total_price % 100 ? 2 : 0 }).format(c.total_price / 100); }
        catch (e) { total = fmt(c.total_price); }
        paint(thumbs, c.item_count || cartCount, total);
      })
      .catch(function () {});
  }
  function exitShow() {
    if (!exitEligible()) return;
    exitShown = true;
    try { sessionStorage.setItem('h13_exit_seen', '1'); } catch (e) {}
    exitFillBag();
    openOv('exit');
    reserveRender(); // first paint of the popup's countdown; reserveSync keeps it ticking while open
  }
  function exitClose(remember) {
    if (remember) { try { localStorage.setItem('h13_exit_dismissed', String(Date.now())); } catch (e) {} }
    closeOv('exit');
  }
  /* the back gesture is the mobile exit signal: hold one spare history entry while the
     bag has something in it, spend it on the popup, and let "I'm leaving" really leave */
  function exitArmBack() {
    if (exitBackTrap || !exitCfg().enabled || cartCount < 1 || exitSuppressed()) return;
    try { history.pushState({ h13Exit: true }, '', location.href); exitBackTrap = true; } catch (e) {}
  }
  function exitArm() {
    if (exitArmed || !exitCfg().enabled) return;
    exitArmed = true;
    // desktop: leaving through the top edge, with no element under the cursor
    document.addEventListener('mouseout', function (e) {
      if (e.clientY > 0 || e.relatedTarget || e.buttons) return;
      exitShow();
    });
    // mobile: the trapped back entry
    window.addEventListener('popstate', function (e) {
      if (!exitBackTrap) return;
      var st = e.state || {};
      if (st.h13Nav || st.h13Swipe) return;  // an instant-nav / swipe entry, not ours
      exitBackTrap = false;
      if (exitEligible()) { history.pushState({ h13Exit: true }, '', location.href); exitBackTrap = true; exitShow(); return; }
      // not eligible (shown already, cooldown, bag empty): the back press must never be
      // swallowed by the spare entry, so it goes through to the real previous page
      try { history.back(); } catch (err) {}
    });
    exitArmBack();

    /* ---- the mobile signals (2026-09-04) --------------------------------------
       92% of 17H13's ad spend lands on phones and 1.1% on desktop, so the classic
       cursor-leaves-the-top trigger above covers almost nobody. Worse, 99% of spend
       is Facebook/Instagram placements, which means most sessions run inside those
       apps' IN-APP browser - there is no tab to close and often no visible back
       button, so the history trap alone misses the common way people leave: they
       swipe back to the feed.

       RETURN-FROM-BACKGROUND catches exactly that. We cannot draw anything while the
       page is hidden (nobody would see it), so instead we note that they left with a
       bag, and greet them with the offer when they come back. That is a better moment
       anyway - they have chosen to return. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (cartCount > 0) { try { sessionStorage.setItem('h13_exit_left', String(Date.now())); } catch (e) {} }
        return;
      }
      var away = 0;
      try { away = Date.now() - (+sessionStorage.getItem('h13_exit_left') || 0); } catch (e) {}
      try { sessionStorage.removeItem('h13_exit_left'); } catch (e) {}
      var min = (exitCfg().returnAfter || 0) * 1000;
      if (!min || !away || away < min) return;      // a glance at a notification is not an exit
      setTimeout(exitShow, 600);                    // let the page settle first
    });

    /* IDLE: on a phone there is no cursor to read, so a long stall with a full bag is
       the only other honest "they are gone" signal. Off unless a delay is configured. */
    var idleMs = (exitCfg().idleAfter || 0) * 1000;
    if (idleMs) {
      var idleT = null;
      var bump = function () {
        clearTimeout(idleT);
        idleT = setTimeout(exitShow, idleMs);
      };
      ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (ev) {
        document.addEventListener(ev, bump, { passive: true });
      });
      bump();
    }
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-exit-dismiss]')) { e.preventDefault(); exitClose(true); return; }
    if (e.target.closest('[data-exit-leave]')) {
      e.preventDefault(); exitClose(true);
      // they asked to go: spend the trapped entry for real
      if (history.length > 1) history.back();
      return;
    }
    var a = e.target.closest('[data-exit-apply]');
    if (a) {
      e.preventDefault();
      var code = (exitCfg().code || '').trim();
      a.disabled = true; a.setAttribute('data-busy', '1'); a.textContent = 'Applying…';
      // /discount/CODE sets Shopify's discount cookie - the same path the first-order
      // code uses - then the bag is re-rendered so its rows show the real numbers
      fetch('/discount/' + encodeURIComponent(code), { keepalive: true })
        .then(function () { refreshBag(); })
        .catch(function () {})
        .then(function () {
          exitClose(true);
          a.disabled = false; a.removeAttribute('data-busy'); a.textContent = 'Apply and keep shopping';
          openOv('bag');
        });
    }
  });

  /* ---------- instant navigation (2026-09-03) ----------------------------------
     Ily: "the page shouldn't reload every time we click between each collection page."

     Two independent layers, both conservative:

     1) PREFETCH ON INTENT - on hover / touch-start / keyboard focus of any internal
        link we warm the HTML into a small in-memory cache. This alone makes a normal
        full-page click feel instant and carries ZERO behavioural risk, because the
        browser still navigates exactly as before.

     2) SAME-DOCUMENT SWAP - a click whose TARGET is a /collections/ URL is handled in
        the page: fetch the HTML, swap <main id="main"> only, update the title and the
        URL, restore scroll, then re-run the same three initialisers the theme already
        calls after a Shopify section render. Everything outside <main> (header,
        announcement bar, bag drawer, footer, overlays) is untouched and keeps its
        state - which is the whole point: the bag stays warm, nothing re-downloads.

     Deliberately NOT swapped, because each carries scripts or tracking that only run
     on a real page load: product pages, cart, account, search, checkout, and the
     home page (its hero carousel builds clones in boot() and cannot be re-initialised
     safely). Those still navigate normally - and still benefit from the prefetch.

     TRACKING NOTE: Shopify's Web Pixels (the Meta pixel among them) emit page_viewed
     on real page loads. A swapped collection view does not emit one, so internal
     collection browsing will under-count page views. Landing Page View from an ad is
     unaffected - that is always a real load - and so are add-to-cart and checkout.
     If measurement fidelity on collection views matters more than the feel, set
     h13Cfg.instantNav = false in the layout and this whole layer stays off.
  ------------------------------------------------------------------------------- */
  var NAV_CACHE = {};
  var NAV_ORDER = [];
  var NAV_MAX = 12;
  var navToken = 0;

  function navEnabled() { return CFG.instantNav !== false; }

  function sameOrigin(url) {
    try { return new URL(url, location.href).origin === location.origin; } catch (e) { return false; }
  }
  function isCollectionUrl(url) {
    try {
      var u = new URL(url, location.href);
      if (u.origin !== location.origin) return false;
      // a product URL can be nested under a collection - that is a PDP, not a grid
      if (!/^\/collections\//.test(u.pathname)) return false;
      if (u.pathname.indexOf('/products/') > -1) return false;
      // ?view=... selects an ALTERNATE TEMPLATE with its own section. SETS is
      // /collections/all?view=sets -> templates/collection.sets.json -> the sets-grid
      // section, NOT main-collection. Shopify happily answers section_id=main-collection
      // on that URL with the ordinary product grid (200, not 404), so a swap would
      // quietly replace the sets layout with the wrong page. Let these navigate for real.
      if (u.searchParams.get('view')) return false;
      return true;
    } catch (e) { return false; }
  }
  function navKey(url) { try { var u = new URL(url, location.href); return u.pathname + u.search; } catch (e) { return url; } }

  /* The collection template is one section (templates/collection.json -> main-collection),
     and <main> contains exactly that section - so the Section Rendering API returns the
     whole swap payload and nothing else. Measured 2026-09-03 on /collections/rings:
     34.5 KB from the section endpoint vs 140.6 KB for the full document, byte-identical
     to what <main> holds. Same call the infinite grid already makes. */
  var NAV_SECTION = 'main-collection';
  function navSectionUrl(url) {
    try {
      var u = new URL(url, location.href);
      u.searchParams.set('section_id', NAV_SECTION);
      return u.pathname + u.search;
    } catch (e) { return null; }
  }
  // "Rings — 17H13" -> " — 17H13": captured once so a swapped page can rebuild its title
  var TITLE_SUFFIX = (function () {
    var t = document.title || '';
    var i = t.lastIndexOf(' — ');
    if (i === -1) i = t.lastIndexOf(' | ');
    return i > -1 ? t.slice(i) : '';
  })();

  function navRemember(key, html) {
    if (NAV_CACHE[key]) return;
    NAV_CACHE[key] = html;
    NAV_ORDER.push(key);
    while (NAV_ORDER.length > NAV_MAX) { delete NAV_CACHE[NAV_ORDER.shift()]; }
  }
  function navFetch(url) {
    var key = navKey(url);
    if (NAV_CACHE[key]) return Promise.resolve(NAV_CACHE[key]);
    var target = navSectionUrl(url) || url;
    return fetch(target, { credentials: 'same-origin', headers: { 'X-Requested-With': 'h13-nav' } })
      .then(function (r) { if (!r.ok) throw new Error('nav ' + r.status); return r.text(); })
      .then(function (html) { navRemember(key, html); return html; });
  }

  /* ---- layer 1: prefetch on intent ---- */
  var prefetched = {};
  function linkFrom(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return null;
    if (a.hasAttribute('download') || (a.getAttribute('target') || '') === '_blank') return null;
    if (!sameOrigin(href)) return null;
    var p;
    try { p = new URL(href, location.href).pathname; } catch (err) { return null; }
    // never touch anything that mutates or leaves the storefront
    if (/^\/(cart|checkout|account|challenge|apps|services)(\/|$)/.test(p)) return null;
    return a;
  }
  function prefetch(e) {
    if (!navEnabled()) return;
    var a = linkFrom(e);
    if (!a) return;
    var key = navKey(a.href);
    if (prefetched[key] || NAV_CACHE[key]) return;
    prefetched[key] = 1;
    // a slow connection or data-saver should not spend bytes on a guess
    var c = navigator.connection;
    if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
    navFetch(a.href).catch(function () { delete prefetched[key]; });
  }

  /* ---- layer 2: same-document swap for collection pages ---- */
  function navCloseOverlays() {
    OV_KEYS.forEach(function (k) { if (state.ov[k]) closeOv(k); });
  }
  function navReinit() {
    initReveals();
    initCardReveal();
    initInfiniteGrid();
  }
  function navApply(html, url, restoreY) {
    var here = document.getElementById('main');
    if (!here) return false;
    // the section endpoint returns the section itself; a full document (the fallback
    // path, and anything served by a cache that ignored the query) needs unwrapping
    if (/^\s*<(!doctype|html)/i.test(html)) {
      var doc;
      try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { return false; }
      var fresh = doc.getElementById('main');
      if (!fresh) return false;
      here.innerHTML = fresh.innerHTML;
      var t = doc.querySelector('title');
      if (t) document.title = t.textContent;
    } else {
      // a section response that carries no grid is not a collection page we can show;
      // refuse the swap so navGo falls back to a real navigation
      if (html.replace(/\s+/g, '').length < 200 || html.indexOf('h13-grid') === -1) return false;
      here.innerHTML = html;
      var h1 = here.querySelector('h1');
      if (h1 && h1.textContent.trim()) document.title = h1.textContent.trim() + TITLE_SUFFIX;
    }
    // the template class drives page-scoped CSS; keep it in step
    CFG.template = 'collection';
    window.scrollTo(0, restoreY || 0);
    navReinit();
    // Shopify Web Pixels do not see a swap; fire the theme pixel if one is present
    try { if (window.fbq) window.fbq('track', 'PageView'); } catch (e) {}
    document.dispatchEvent(new CustomEvent('h13:navigated', { detail: { url: url } }));
    return true;
  }
  function navGo(url, push, restoreY) {
    var mine = ++navToken;
    document.documentElement.classList.add('h13-navving');
    return navFetch(url)
      .then(function (html) {
        if (mine !== navToken) return;              // a newer click won
        if (!navApply(html, url, restoreY)) { location.assign(url); return; }
        if (push) history.pushState({ h13Nav: true, y: 0 }, '', url);
        bumpPageView(); emailScrolled = false; maybeEmail();
      })
      .catch(function () { location.assign(url); })
      .then(function () { if (mine === navToken) document.documentElement.classList.remove('h13-navving'); });
  }

  document.addEventListener('mouseover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch, { passive: true });

  document.addEventListener('click', function (e) {
    if (!navEnabled()) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = linkFrom(e);
    if (!a || !isCollectionUrl(a.href)) return;
    // same page (a chip for the collection we are already on): just go to the top
    if (navKey(a.href) === navKey(location.href)) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    e.preventDefault();
    // The menu overlay carries six collection links. Swapping the page underneath an
    // open overlay left it covering the screen with the scroll still locked, which read
    // as "the menu button is broken" (found by Ily 2026-09-03). Any overlay the click
    // came from has to close, exactly as a real navigation would have discarded it.
    navCloseOverlays();
    // remember where we were, so Back lands where they left off
    try { history.replaceState({ h13Nav: true, y: window.pageYOffset }, '', location.href); } catch (err) {}
    navGo(a.href, true, 0);
  });

  window.addEventListener('popstate', function (e) {
    if (!navEnabled()) return;
    // only OUR entries are swappable; anything else (a PDP, home, the cart) is a real
    // document and must load properly
    if (!isCollectionUrl(location.href)) return;
    var st = e.state || {};
    if (!st.h13Nav) return;
    navGo(location.href, false, st.y || 0);
  });

  /* ---- collection sort dropdown: close on outside click / Escape ----
     This lived as an inline <script> inside sections/main-collection.liquid, which
     stops working the moment the section is swapped in (scripts inserted as HTML do
     not execute). Delegated here so it survives navigation. */
  document.addEventListener('pointerdown', h13SortAway, true);
  document.addEventListener('focusin', h13SortAway, true);
  function h13SortAway(e) {
    $$('details[data-h13-sort][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('details[data-h13-sort][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });

  function boot() {
    root = document.getElementById('h13-root');
    // the old theme's spin-wheel left its ticket in storage; V3 has no wheel and the
    // codes it named are gone — clear it so nothing ever reads a dead code back
    try { localStorage.removeItem('17h13_spin_v1'); } catch (e) {}
    // Shopify's video_tag writes a poster <img> with no alt inside every <video>; it is
    // decorative (the section names itself), so mark it so for screen readers
    $$('video > img:not([alt])').forEach(function (i) { i.setAttribute('alt', ''); });

    // prototype theme persistence (only when the rail is enabled)
    if (CFG.protoControls) {
      var stored = null;
      try { stored = localStorage.getItem('h13v2_theme'); } catch (e) {}
      if (stored === 'dark' || stored === 'light') applyTheme(stored);
      syncProtoButtons();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    bumpPageView();
    reserveCacheRefresh();
    reserveSync();

    // hero carousel: dots, autoplay (video slides advance on ended, others on interval),
    // and WRAP-AROUND — swiping left from the first slide lands on the last, swiping
    // right from the last lands on the first (Adam 2026-08-19). The track is a native
    // scroll-snap row; the loop is done the classic way: a clone of the last slide sits
    // before the first and a clone of the first after the last, and the moment the
    // track settles on a clone it is jumped (instantly, behind the identical frame) to
    // the real slide. Track index t runs 0..n+1, real index r = (t - 1 + n) % n.
    var hero = $('[data-hero-scroll]');
    if (hero) {
      // slides can be scoped to a device (Show on / Desktop slide) — hidden ones take
      // no space in the track, so everything below counts only what is visible now
      var visible = function (el) { return getComputedStyle(el).display !== 'none'; };
      var allDots = $$('[data-hero-dot]');
      var allSlides = Array.prototype.slice.call(hero.children).filter(function (el) { return !el.hasAttribute('data-hero-clone'); });
      var dots = [];
      var heroSlides = [];     // the real, visible slides
      var looped = false;      // clones in place?
      var heroIdx = 0;         // real index
      // slide pitch, not track width: slides are calc(100% - 12px) wide for the next-slide
      // peek, so index math measures the real slide (offsetLeft delta covers any gap)
      var w = function () {
        var a = hero.children[0], b = hero.children[1];
        var pitch = b && a ? b.offsetLeft - a.offsetLeft : (a ? a.offsetWidth : 0);
        return pitch > 0 ? pitch : (hero.clientWidth || 1);
      };
      var trackOf = function (r) { return looped ? r + 1 : r; };
      var realOf = function (t) { var n = heroSlides.length || 1; return looped ? ((t - 1) % n + n) % n : Math.max(0, Math.min(n - 1, t)); };
      var trackIdx = function () { return Math.round(hero.scrollLeft / w()); };

      function makeClone(src) {
        var c = src.cloneNode(true);
        c.setAttribute('data-hero-clone', '');
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('id');
        $$('[id]', c).forEach(function (el) { el.removeAttribute('id'); });
        // a clone never plays video: swap each <video> for its poster so the frame the
        // shopper lands on during the wrap is a picture, not a blank box
        $$('video', c).forEach(function (v) {
          var poster = v.getAttribute('poster') || (v.querySelector('img') && v.querySelector('img').getAttribute('src')) || '';
          if (poster) {
            var img = document.createElement('img');
            img.src = poster; img.alt = ''; img.className = v.className || 'h13-media-cover';
            v.parentNode.replaceChild(img, v);
          } else { v.parentNode.removeChild(v); }
        });
        return c;
      }
      function buildLoop() {
        $$('[data-hero-clone]', hero).forEach(function (c) { c.parentNode.removeChild(c); });
        dots = allDots.filter(visible);
        heroSlides = allSlides.filter(visible);
        looped = heroSlides.length > 1;
        if (looped) {
          hero.insertBefore(makeClone(heroSlides[heroSlides.length - 1]), hero.firstChild);
          hero.appendChild(makeClone(heroSlides[0]));
        }
        heroIdx = 0;
        hero.scrollLeft = trackOf(0) * w();   // same frame as the clone insert — nothing moves on screen
        paintDots();
      }
      function paintDots() {
        dots.forEach(function (d, idx) {
          d.style.background = idx === heroIdx ? 'var(--text)' : 'var(--hairline)';
        });
      }
      buildLoop();
      if (desktopMQ) {
        var onHeroMQ = function () { buildLoop(); armHero(); syncViewportMedia(); };
        if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', onHeroMQ);
        else if (desktopMQ.addListener) desktopMQ.addListener(onHeroMQ);
      }

      var autoplayOn = hero.getAttribute('data-hero-autoplay') !== 'false' && allSlides.length > 1;
      var interval = (parseInt(hero.getAttribute('data-hero-interval'), 10) || 5) * 1000;
      var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var heroTimer = null;
      var holdUntil = 0;
      var heroTouching = false;

      /* wrapJump(): when the track has come to rest on a clone, jump to the twin real
         slide with no animation. Called from settle and from the scroll-end debounce. */
      function wrapJump() {
        if (!looped || heroTouching) return false;
        var n = heroSlides.length, t = trackIdx();
        if (t === 0) { hero.scrollTo({ left: n * w(), behavior: 'auto' }); return true; }
        if (t === n + 1) { hero.scrollTo({ left: 1 * w(), behavior: 'auto' }); return true; }
        return false;
      }

      /* A smooth scrollTo that gets interrupted — tab backgrounded mid-animation, a
         rotate that changes clientWidth while scrollLeft stays in old pixels, a finger
         landing during the glide — leaves the track parked between two slides. scroll-snap
         does not always pull it back on its own. settleHero() re-asserts the nearest slide
         edge whenever the track is found off-grid and nobody is touching it. */
      var settleTimer = null;
      function settleHero(immediate) {
        clearTimeout(settleTimer);
        var run = function () {
          if (heroTouching || heroSlides.length < 1) return;
          var maxT = looped ? heroSlides.length + 1 : heroSlides.length - 1;
          var t = Math.max(0, Math.min(maxT, trackIdx()));
          var target = t * w();
          if (Math.abs(hero.scrollLeft - target) <= 1) { wrapJump(); heroIdx = realOf(trackIdx()); paintDots(); return; }
          // off-grid: only intervene once the track has actually stopped moving
          var before = hero.scrollLeft;
          setTimeout(function () {
            if (heroTouching || Math.abs(hero.scrollLeft - before) > 1) { settleHero(); return; }
            hero.scrollTo({ left: target, behavior: 'auto' });
            wrapJump();
            heroIdx = realOf(trackIdx()); paintDots();
          }, 160);
        };
        if (immediate) run(); else settleTimer = setTimeout(run, 900);
      }
      hero.addEventListener('touchstart', function () { heroTouching = true; }, { passive: true });
      ['touchend', 'touchcancel'].forEach(function (ev) { hero.addEventListener(ev, function () { heroTouching = false; settleHero(); }, { passive: true }); });
      window.addEventListener('resize', function () { settleHero(true); }, { passive: true });
      window.addEventListener('orientationchange', function () { setTimeout(function () { settleHero(true); }, 120); });
      window.addEventListener('pageshow', function () { settleHero(true); });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) settleHero(true); });

      // live index while the track moves; a short debounce after the last scroll event
      // (plus scrollend where the browser has it) performs the wrap jump
      var heroSyncTimer = null, heroEndTimer = null;
      function onHeroScrollEnd() { if (wrapJump()) { heroIdx = realOf(trackIdx()); paintDots(); } syncViewportMedia(); }
      hero.addEventListener('scroll', function () {
        heroIdx = realOf(trackIdx());
        paintDots();
        armHero();
        clearTimeout(heroSyncTimer);
        heroSyncTimer = setTimeout(syncViewportMedia, 120);
        clearTimeout(heroEndTimer);
        heroEndTimer = setTimeout(onHeroScrollEnd, 140);
      }, { passive: true });
      if ('onscrollend' in hero) hero.addEventListener('scrollend', function () { clearTimeout(heroEndTimer); onHeroScrollEnd(); });

      function goTo(i) {
        var n = heroSlides.length;
        if (n < 2) return;
        var next = ((i % n) + n) % n;
        var t = trackOf(next);
        // advancing past the last slide rides onto the clone of the first (t = n + 1), so
        // the motion reads as forward; the scroll-end jump then lands on the real first
        if (looped && heroIdx === n - 1 && next === 0) t = n + 1;
        if (looped && heroIdx === 0 && next === n - 1) t = 0;
        hero.scrollTo({ left: t * w(), behavior: reduced ? 'auto' : 'smooth' });
        settleHero();
        // a slide can carry mobile+desktop video variants — restart only the visible one
        $$('video', heroSlides[next]).forEach(function (v) {
          var box = v.closest ? v.closest('.h13-mq-m,.h13-mq-d') : null;
          if (box && getComputedStyle(box).display === 'none') return;
          try {
            if (v.readyState > 0) v.currentTime = 0;
            playVideo(v);
          } catch (e) {}
        });
        syncViewportMedia();
      }

      function armHero() {
        if (!autoplayOn) return;
        clearTimeout(heroTimer);
        if (heroSlides.length < 2) return;
        var v = heroSlides[heroIdx] && heroSlides[heroIdx].querySelector('video');
        var wait = interval;
        if (v && !v.loop && isFinite(v.duration) && v.duration > 0) {
          var left = Math.max(0.5, v.duration - v.currentTime);
          wait = Math.min(left * 1000 + 250, 30000);
        }
        heroTimer = setTimeout(function () {
          if (document.hidden || Date.now() < holdUntil) { armHero(); return; }
          goTo(heroIdx + 1);
        }, wait);
      }

      if (autoplayOn) {
        allSlides.forEach(function (s) {
          var v = s.querySelector('video');
          if (v) v.addEventListener('ended', function () {
            if (heroSlides.indexOf(s) === heroIdx && Date.now() >= holdUntil && !document.hidden) goTo(heroIdx + 1);
          });
        });
        ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
          hero.addEventListener(ev, function () { holdUntil = Date.now() + 8000; armHero(); }, { passive: true });
        });
        document.addEventListener('visibilitychange', armHero);
        armHero();
      }
    }

    // announcement strip: rotate through its messages (the setting split on " · ")
    // with a quiet rise every 4s; pauses while the tab is hidden; one message = static
    var ann = $('[data-announce]');
    var annItems = ann ? $$('[data-ann-item]', ann) : [];
    if (annItems.length > 1) {
      var annIdx = 0;
      var annTimer = null;
      // sequential: the current line fades out (.15s), THEN (160ms later) the next rises in.
      // Never two lines visible at once; any count of items (2, 3, ...) cycles the same way.
      var annBusy = false;
      var annStep = function () {
        if (document.hidden || annBusy) return;
        annBusy = true;
        var cur = annItems[annIdx];
        annIdx = (annIdx + 1) % annItems.length;
        var nxt = annItems[annIdx];
        annItems.forEach(function (it) { if (it !== cur) { it.classList.remove('on', 'out'); it.setAttribute('aria-hidden', 'true'); } });
        // slide: the next line rises the moment the current one leaves (2026-09-17 audit: no blank frame)
        cur.classList.remove('on'); cur.classList.add('out'); cur.setAttribute('aria-hidden', 'true');
        nxt.classList.add('on'); nxt.removeAttribute('aria-hidden');
        setTimeout(function () {
          cur.classList.remove('out');
          annBusy = false;
        }, 320);
      };
      var annArm = function () { clearInterval(annTimer); annTimer = setInterval(annStep, 4000); };
      document.addEventListener('visibilitychange', function () { if (!document.hidden) annArm(); });
      annArm();
    }

    // PDP wiring (counter IO, sticky bar, more-cards, strip, swipe arming) —
    // extracted so it can re-run after a swipe swap
    if (CFG.template === 'product') initPdpScoped();

    try {
      var posted = !!document.querySelector('[data-newsletter-confirmed]');
      var wasNative = sessionStorage.getItem('h13v2_email_native') === '1';
      if (posted) {
        markJoined();
        sessionStorage.removeItem('h13v2_email_native');
        if (wasNative) {
          emailState.step = EMAIL_DONE; saveEmailState();
          emailFired = true; setEmailStep(EMAIL_DONE); openOv('email');
          stampKlaviyoProfile(fillCaptureForm());
        }
      } else if (wasNative && document.querySelector('[data-newsletter-errors]')) {
        emailState.step = 1; saveEmailState();
        emailFired = true; setEmailStep(1); openOv('email');
      }
    } catch (e) {}
    // email capture clock
    if (CFG.emailEnabled && CFG.template === 'index' && !emailSuppressed()) {
      elapsed = 0;
      emailTimer = setInterval(function () {
        elapsed++;
        try { sessionStorage.setItem('h13v2_elapsed', String(elapsed)); } catch (e) {}
        maybeEmail();
      }, 1000);
      maybeEmail();
    }

    // per-viewport media variants: correct video plays on load and across the breakpoint
    syncViewportMedia();
    if (desktopMQ && desktopMQ.addEventListener) desktopMQ.addEventListener('change', syncViewportMedia);

    refreshDiscountUI();
    healDiscountCookie();
    watchWallets();
    // announcement whose every message resolved blank (e.g. only [offer], outside its
    // window) renders no bar; drop the chrome offset theme.liquid set for it
    if (!$('[data-announce]')) document.documentElement.classList.remove('h13-ann-on');
    setTimeout(initReveals, 500);
    initCardReveal();
    initInfiniteGrid();
    exitArm();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // theme editor + bfcache resilience
  document.addEventListener('shopify:section:load', function () { setTimeout(initReveals, 150); initCardReveal(); initInfiniteGrid(); });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    // bfcache restore: a swipe caught mid-gesture, or an overlay open at the moment the
    // user left, comes back with the column translated / body scroll locked — the page
    // reads as dead. Put geometry and overlay state back to rest, then refresh the cart.
    try {
      OV_KEYS.forEach(function (k) { state.ov[k] = false; });
      syncOv();
    } catch (err) {}
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.item_count === 'number') updateCount(c.item_count); })
      .catch(function () {});
    healDiscountCookie();
    refreshBag();
    reserveSync();
  });
  // try-on evaluation: shimmer keyframes + first render on the server-rendered drawer
  if (tryonMode()) {
    var ts = document.createElement('style');
    ts.textContent = '@keyframes h13TryonSh{to{background-position:-120% 0}}@media (prefers-reduced-motion:reduce){[data-tryon] *{animation:none!important}}';
    document.head.appendChild(ts);
  }
  renderTryon();
})();

/* ---- shipping timeline (PDP): Order today / Dispatched / Delivered, dated client-side ----
   Windows come from snippets/shipping-timeline.liquid data attributes (the fulfiller's
   published 1-2 business day dispatch + per-market delivery). Clock is America/New_York,
   2pm ET cut-off, Mon-Fri, US federal holidays skipped. Exposed as window.h13ShippingTimeline
   so section re-renders can call it; also re-runs on h13:navigated. Self-contained. */
(function () {
  var TZ = 'America/New_York';
  var CUTOFF_H = 14;
  var HOLIDAYS = { '2026-10-12': 1, '2026-11-11': 1, '2026-11-26': 1, '2026-12-25': 1 };
  var partsFmt, dateFmt, tick = null;
  function fmtParts() {
    if (!partsFmt) partsFmt = new Intl.DateTimeFormat('en-US', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', weekday: 'short' });
    var out = {};
    partsFmt.formatToParts(new Date()).forEach(function (p) { out[p.type] = p.value; });
    return out;
  }
  // a calendar day in NY, carried as a UTC-noon Date so day arithmetic never crosses a DST edge
  function dayFromParts(p) { return new Date(Date.UTC(+p.year, +p.month - 1, +p.day, 12)); }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function isBiz(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !HOLIDAYS[iso(d)]; }
  function nextBiz(d) { var x = d; while (!isBiz(x)) x = addDays(x, 1); return x; }
  function addBiz(d, n) { var x = d; while (n > 0) { x = addDays(x, 1); if (isBiz(x)) n--; } return x; }
  function fmtDay(d) {
    if (!dateFmt) dateFmt = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
    var o = {};
    dateFmt.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return { wd: o.weekday, day: o.day, mon: o.month, text: o.weekday + ' ' + o.day + ' ' + o.month };
  }
  function fmtRange(a, b) {
    if (iso(a) === iso(b)) return fmtDay(a).text;
    var fa = fmtDay(a), fb = fmtDay(b);
    if (fa.mon === fb.mon) return fa.wd + ' ' + fa.day + ' to ' + fb.wd + ' ' + fb.day + ' ' + fb.mon;
    return fa.text + ' to ' + fb.text;
  }
  function compute(el) {
    var p = fmtParts();
    var today = dayFromParts(p);
    var mins = (+p.hour) * 60 + (+p.minute);
    var openDay = isBiz(today) && mins < CUTOFF_H * 60;
    // the order counts from today if placed before the cut-off on a business day, else from the next business day
    var base = openDay ? today : nextBiz(addDays(today, 1));
    var dmin = +el.getAttribute('data-dispatch-min') || 1, dmax = +el.getAttribute('data-dispatch-max') || 2;
    var vmin = +el.getAttribute('data-deliver-min') || 0, vmax = +el.getAttribute('data-deliver-max') || 0;
    var dispA = addBiz(base, dmin), dispB = addBiz(base, dmax);
    var res = { today: today, dispA: dispA, dispB: dispB, openDay: openDay, minsLeft: CUTOFF_H * 60 - mins, hasDeliver: vmax > 0 };
    if (vmax > 0) { res.delA = addBiz(base, Math.max(vmin, dmin)); res.delB = addBiz(base, vmax); } // window is total from order, dispatch included (shipping policy)
    return res;
  }
  function cutoffLine(r) {
    // "tomorrow" only when the earliest dispatch day really is the next calendar day (Fri / holiday eve name the date)
    var when = iso(r.dispA) === iso(addDays(r.today, 1)) ? 'tomorrow' : 'by ' + fmtDay(r.dispA).text;
    if (r.openDay) {
      var h = Math.floor(r.minsLeft / 60), m = r.minsLeft % 60;
      var span = h > 0 ? h + 'h ' + (m < 10 ? '0' : '') + m + 'm' : m + 'm';
      return 'Order in the next ' + span + ' for dispatch ' + when;
    }
    return 'Order by 2pm ET for dispatch ' + when;
  }
  function render() {
    var els = document.querySelectorAll('[data-shipping-timeline]');
    var stickies = document.querySelectorAll('[data-sticky-dispatch]');
    if (!els.length && !stickies.length) return;
    var first = null;
    Array.prototype.forEach.call(els, function (el) {
      var r;
      try { r = compute(el); } catch (e) { return; }
      if (!first) first = r;
      var set = function (k, v) { var n = el.querySelector('[data-ship-date="' + k + '"]'); if (n) n.textContent = v; };
      set('order', fmtDay(r.today).text);
      set('dispatch', fmtRange(r.dispA, r.dispB));
      var track = el.querySelector('[data-ship-track]');
      if (track) track.hidden = false;
      if (r.hasDeliver) set('deliver', fmtRange(r.delA, r.delB));
      else if (track) track.classList.add('h13-ship-track--two');
      var c = el.querySelector('[data-ship-cutoff]');
      if (c) { c.textContent = cutoffLine(r); c.hidden = false; }
      el.classList.add('is-ready');
    });
    if (!first && stickies.length) {
      try { first = compute(stickies[0]); } catch (e) { first = null; }
    }
    if (first) {
      var s = 'Dispatched by ' + fmtDay(first.dispB).text;
      Array.prototype.forEach.call(stickies, function (n) { n.textContent = s; });
    }
    if (!tick) tick = setInterval(function () { if (!document.querySelector('[data-shipping-timeline]')) { clearInterval(tick); tick = null; return; } render(); }, 60000);
  }
  window.h13ShippingTimeline = render;
  document.addEventListener('h13:navigated', render);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();

document.addEventListener('click',function(e){var a=e.target.closest('[data-denim-fit-open]');if(!a)return;var t=document.getElementById('denim-fit-details');if(!t)return;var box=t.closest('[data-acc-content]');if(box){box.hidden=false;var button=box.parentElement.querySelector('[data-acc-toggle]');if(button)button.setAttribute('aria-expanded','true');} });
